"use strict";

var ew = {};

(function() {

	/***************************************
		Common methods
	***************************************/

	var isTouchDevice = function() { return 'ontouchstart' in window || navigator.maxTouchPoints; }
	var vpWidth = function() { return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); }
	var vpHeight = function() { return Math.max(document.documentElement.clientHeight, window.innerHeight || 0); }
	var getScrollingElement = function() { return document.scrollingElement ? document.scrollingElement : document.documentElement; }
	var getScrollPos = function() { return getScrollingElement().scrollTop || window.pageYOffset; }
	var isIE = function() { return document.body.classList.contains('is-ie'); };
	var isFirefox = function() { return document.body.classList.contains('is-firefox'); };
	var isSafari = function() { return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') == -1; }

	function xhrCors(method, url, async) {
		var xhr = new XMLHttpRequest();
		async = async || false;

		if ("withCredentials" in xhr) {
			xhr.open(method, url, async);
		} else if (typeof XDomainRequest != "undefined") {
				xhr = new XDomainRequest();
			xhr.open(method, url);
		} else {
			xhr = null;
		}

		return xhr;
	}

	function debounce(func, delay) {
		var wait;

		delay = delay || 50;
		return (function() {
			var context = this,
				args = arguments;

			clearTimeout(wait);
			wait = setTimeout(function() {
				func.apply(context, args);
			}, delay);
		})();
	}

	/***************************************
		Main Events
	***************************************/

	var imgPreloader, vidPreloader, resizer;

	var init = function() {
		imgPreloader      = new ImagePreloader();
		vidPreloader      = new VideoPreloader();
		resizer           = resizeBody();

		resizeIframes();
		autoSwitchMenu();
		headerMenus();
		search();
		sliders();
		expandableItems();
		contactForms();
		showLanguageSubMenu();
		videos();
		infoBar();
		circleHighlight();
		leftRightSections();
		logoBar();
		infinityScroller();
		maintenanceCheck();
		hideHeaderBar();
		smartTiles();
		checklist();

		credits();

		setTimeout(updateHeaderHeight, 200);
		window.addEventListener('resize', updateHeaderHeight);

		ew = {
			isTouchDevice, vpWidth, vpHeight, getScrollingElement, getScrollPos,
			isIE, isFirefox, isSafari, xhrCors, debounce, resizer, imgPreloader,
			vidPreloader, SwipeDetect, updateHeaderHeight
		};
	}



	var resizeBody = function() {
		var changeHeight = function() {
			var root = document.documentElement,
				height = window.innerHeight,
				width  = vpWidth(),
				vw = 0.01 * document.body.clientWidth,
				vh = 0.01 * window.innerHeight;

			root.style.setProperty('--vw', vw + 'px');
			root.style.setProperty('--vh', vh + 'px');
			document.body.style.height = window.innerHeight + 'px';
		}

		setTimeout(changeHeight, 20);
		window.addEventListener('resize', changeHeight);

		return changeHeight;
	}

	var updateHeaderHeight = function() {
		var root   = document.documentElement,
			header = document.querySelector('.header'),
			footer = document.querySelector('.footer');

		if (header) root.style.setProperty('--headerHeight', header.getBoundingClientRect().height + 'px');
		if (footer) root.style.setProperty('--footerHeight', footer.getBoundingClientRect().height + 'px');
	}




	/**************************************************
		Lazy Loading
	**************************************************/

	class ImagePreloader {
		constructor(wrapper) {
			this.wrapper = wrapper || document;
			this.images  = [].slice.call(this.wrapper.querySelectorAll('img.lazy'));

			if ('loading' in document.createElement('img'))
				return this.loadImagesNow();

			this.prepareImages();
			this.checkVisibility();
			this.registerEvents();
		}

		prepareImages() {
			this.images.forEach(function(image) {
				if (image.nextElementSibling && image.nextElementSibling.tagName === 'NOSCRIPT')
					image.parentElement.removeChild(image.nextElementSibling);

				var parentWidth   = image.parentElement.scrollWidth,
					naturalWidth  = image.getAttribute('width'),
					naturalHeight = image.getAttribute('height'),
					newHeight     = naturalHeight * parentWidth / naturalWidth;

				image.style.height = newHeight  + 'px';
			});
		}

		checkVisibility(threshold = 0) {
			if (this.images.length == 0) return;

			debounce((function() {				
				var winWidth  = vpWidth(),
					winHeight = vpHeight();

				this.images = this.images.filter((function(image) {
					var clientRect = image.getBoundingClientRect();

					if (clientRect.top + clientRect.height < threshold * winHeight) return true;
					if (clientRect.top                     < threshold * winHeight) return true;
					if (clientRect.left + clientRect.width < threshold * winWidth) return true;
					if (clientRect.left                    < threshold * winWidth) return true;

					this.loadImage(image);
					return false;
				}).bind(this));
			}).bind(this));
		};

		loadImage(image) {
			if (!image || !image.classList.contains('lazy')) return;

			image.src    = image.dataset.src;
			image.srcset = image.dataset.srcset;
			image.classList.add('loaded');
			image.style.height = '';

			setTimeout(function() {
				image.classList.remove('lazy', 'loaded');
				image.removeAttribute('data-src');
				image.removeAttribute('data-srcset');
			}, 1000);
		}

		loadImagesNow(wrapper) {
			wrapper = wrapper || document;

			var imgs = wrapper.querySelectorAll('img.lazy');
			[].forEach.call(imgs, (function(img) {
				this.loadImage(img);
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener('scroll', (function() { this.checkVisibility(); }).bind(this), { passive: false });
			window.addEventListener('resize', (function() { this.checkVisibility(); }).bind(this), false);
		}
	}



	class VideoPreloader {
		constructor(wrapper) {
			this.wrapper = wrapper || document;
			this.videos  = [].slice.call(this.wrapper.querySelectorAll('video.lazy'));
			this.threshold = 20;

			this.prepareVideos();
			this.checkVisibility();
			this.registerEvents();
		}

		prepareVideos() {
			this.videos.forEach(function(video) {
				var parentWidth   = video.parentElement.scrollWidth,
					naturalWidth  = video.getAttribute('width'),
					naturalHeight = video.getAttribute('height'),
					newHeight     = naturalHeight * parentWidth / naturalWidth;

				video.style.height = newHeight  + 'px';
			});
		}

		checkVisibility(threshold = 0) {
			if (this.videos.length == 0) return;

			debounce((function() {				
				var winWidth = vpWidth(),
					winHeight = vpHeight();

				this.videos = this.videos.filter((function(video) {
					var clientRect = video.getBoundingClientRect();

					if (clientRect.top + clientRect.height < threshold * winHeight) return true;
					if (clientRect.top                     < threshold * winHeight) return true;
					if (clientRect.left + clientRect.width < threshold * winWidth) return true;
					if (clientRect.left                    < threshold * winWidth) return true;

					let elem    = video,
						visible = true;

					// while (elem && visible == true) {
					// 	let opacity = getComputedStyle(elem).getPropertyValue('opacity');
					// 	visible = visible && (opacity == '' || parseFloat(opacity) !== 0);
					// 	visible = visible && elem.style.display !== 'none';
					// 	visible = visible && elem.style.visibility !== 'hidden';

					// 	elem = elem.parentElement || null;
					// }

					// if (visible == false) return;

					this.loadVideo(video);
					return false;
				}).bind(this));
			}).bind(this));
		};

		loadVideo(elem) {
			if (!elem || elem.loading === true || !elem.classList.contains('lazy')) return;

			elem.loading = true;
			elem.classList.add('is-loading');

			var files   = JSON.parse(elem.dataset.sources),
				width   = elem.parentElement.getBoundingClientRect().width,
				mimes   = {},
				sources = '';


			files.forEach(function(file) {
				if (!mimes.hasOwnProperty(file.mime)) mimes[file.mime] = [];
				mimes[file.mime].push(file);
			});

			for (var mime in mimes) {
				if (!mimes.hasOwnProperty(mime)) continue;

				var sizes = mimes[mime],
					size;

				if	(sizes.length >= 2) {
					sizes = sizes.filter(function(size, index, arr) {
						return size.width >= width;
					});
				}

				size = (sizes.length > 0) ? sizes[sizes.length - 1] : mimes[mime][0];
				sources += '<source src="' + size.file + '" type="' + mime + '">';
			}

			if (this.threshold > vpWidth()) {
				elem.setAttribute('preload', 'metadata');
			}

			elem.addEventListener('loadedmetadata', function() {
				elem.classList.remove('is-loading');
			});

			elem.innerHTML = sources;
			elem.classList.remove('lazy');
			elem.removeAttribute('data-sources');
			elem.style.height = '';

			if (elem.getAttribute('autoplay'))
				elem.play();
		}

		loadVideosNow(wrapper) {
			wrapper = wrapper || document;

			var videos = wrapper.querySelectorAll('video.lazy');
			[].forEach.call(videos, (function(video) {
				this.loadVideo(video);
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener('scroll', (function() { this.checkVisibility(); }).bind(this), { passive: false });
			window.addEventListener('resize', (function() { this.checkVisibility(); }).bind(this), false);
		}
	}




	/***************************************
		Info bar
	***************************************/

	var infoBar = function() {
		var elem = document.querySelector('.header-infobar');
		if (!elem) return;

		var inner       = elem.querySelector('.header-infobar-inner'),
			btn         = elem.querySelector('.header-infobar-close'),
			cookie      = 'infobarseen_' + hashCode(inner.innerHTML) + '=true',
			showInfoBar = function() {
				elem.classList.remove('hide');
			},
			hideInfoBar = function() {
				elem.classList.add('hide');
				document.cookie = cookie + '; max-age=' + 60*60*24*14;
				setTimeout(updateHeaderHeight, 250);
			},
			resize = function() {
				let height = elem.getBoundingClientRect().height;
				document.documentElement.style.setProperty('--infoBarHeight', height + 'px');
			};

		document.fonts.ready.then(() => setTimeout(resize, 80));
		window.addEventListener('resize', resize);
		btn.addEventListener('click', hideInfoBar);

		if (!document.cookie.split(';').some((item) => item.trim().startsWith(cookie)))
			showInfoBar();
	};

	var hashCode = function(str) {
		var hash = 0, i, chr;

		if (str.length === 0)
			return hash;

		for (i = 0; i < str.length; i++) {
			chr   = str.charCodeAt(i);
			hash  = ((hash << 5) - hash) + chr;
			hash |= 0;
		}

		return hash;
	};




	/***************************************
		Circle highlight
	***************************************/

	var circleHighlight = function() {
		let elems = [].slice.call(document.querySelectorAll('.module-circlehighlight'));
		if (elems.length == 0) return;

		let threshold = 1024;

		elems.forEach(elem => {
			let container = elem.querySelector('.circlehighlight-items'),
				items     = [].slice.call(elem.querySelectorAll('.circlehighlight-item'));
			if (items.length == 0) return;

			let navItems = [].slice.call(elem.querySelectorAll('.circlehighlight-nav-item')),
				ctas     = [].slice.call(elem.querySelectorAll('.cta')),
				current  = null;

			let toggle = function(i, force = false) {
				let inner  = items[i].querySelector('.circlehighlight-item-inner'),
					active = force ? false : items[i].classList.contains('active');

				items[i].classList.toggle('active', !active);
				navItems[i].classList.toggle('active', !active);
				inner.style.maxHeight = active ? '0px' : inner.scrollHeight + 'px';

				if (!active) {
					imgPreloader.loadImagesNow(items[i]);
					vidPreloader.loadVideosNow(items[i]);

					items.forEach((item, index) => {
						if (index == i) return;
						item.classList.remove('active');
						item.querySelector('.circlehighlight-item-inner').style.maxHeight = '0px';
					});

					navItems.forEach((navItem, index) => index !== i ? navItem.classList.remove('active') : null);
				}

				current = i;
			};

			let resize = function() {
				let isLarge = vpWidth() > threshold;

				container.style.minHeight = '';

				if (isLarge) {
					let height = items.reduce((height, item) => Math.max(height, item.scrollHeight), 0);
					container.style.minHeight = height + 'px';
				}

				ctas.forEach(cta => cta.classList.toggle('cta-solid', isLarge));
				ctas.forEach(cta => cta.classList.toggle('cta-outline', !isLarge));

				if (isLarge && current == null) toggle(0);

				items.forEach(item => {
					if (!item.classList.contains('active')) return;
					let inner = item.querySelector('.circlehighlight-item-inner');
					inner.style.maxHeight = inner.scrollHeight + 'px';
				});
			};

			items.forEach((item, i) => {
				let title  = item.querySelector('.circlehighlight-item-title');
				title.addEventListener('click', () => toggle(i));
			});

			navItems.forEach((item, i) => {
				item.addEventListener('mouseenter', () => toggle(i, true));
			});

			window.addEventListener('resize', resize);
			resize();
		});
	}




	/***************************************
		Automatically switch burger menu
	***************************************/

	var autoSwitchMenu = function() {
		let elem       = document.querySelector('.header-menu[data-autoswitchmenu="1"]');
		if (!elem) return;

		let	items      = [].slice.call(elem.querySelectorAll('.menu-item-top-inner')),
			threshold  = 1.5;

		var update = function() {
			elem.classList.remove('force-mobile-menu');

			let lineHeight = parseInt(getComputedStyle(items[0]).lineHeight.split('px')[0]),
				isWrapping = false;

			items.forEach(item => {
				isWrapping = isWrapping || item.offsetHeight >= lineHeight * threshold;
			});

			elem.classList.toggle('force-mobile-menu', isWrapping);
		}

		update();
		window.addEventListener('resize', update);
	}




	/***************************************
		Toggle Menu
	***************************************/

	var headerMenus = function() {
		let headerMenu = new HeaderMenu();
	}

	class HeaderMenu {
		constructor() {
			this.header = document.querySelector('.header');
			if (!this.header) return;

			this.menu          = this.header.querySelector('.header-menu');
			if (!this.menu) return;

			this.toggle        = this.header.querySelector('.header-menu-toggle');
			this.menuItems     = [].slice.call(this.menu.querySelectorAll('.header-menu-inner > ul > .menu-item'));
			this.languages     = this.header.querySelector('.header-menu-languages');

			this.isSideMenu    = this.header.classList.contains('header-side');
			this.doesItSwitch  = this.isSideMenu;
			this.threshold     = this.doesItSwitch ? 1024 : 1024;

			this.isTouchDevice = isTouchDevice();
			this.isSmallDevice = null;
			this.hoverTarget   = null;

			this.registerMenuItems();
			this.resize();
			this.registerEvents();
		}

		registerMenuItems() {
			this.menuItems = this.menuItems.map(menuItem => {
				return {
					element:   	menuItem,
					title:      menuItem.querySelector('.menu-item-top-inner'),
					titleLink:  menuItem.querySelector('.menu-item-top-inner a'),
					hasSubMenu:	menuItem.classList.contains('menu-item-has-children'),
					subMenu:    menuItem.querySelector('.header-megamenu'),
					isVisible: 	false
				};
			});
		}

		resize() {
			this.isSmallDevice = vpWidth() < this.threshold;

			this.menuItems = this.menuItems.map((menuItem => {
				if (!menuItem.hasSubMenu) return menuItem;

				if (this.isTouchDevice) {
					menuItem.subMenu.style.maxHeight = menuItem.isVisible ? menuItem.submenu.scrollHeight + 'px' : 0;
					menuItem.isVisible               = false;
					menuItem.element.classList.remove('show-megamenu')
				} else {
					menuItem.subMenu.style.maxHeight = '';
				}

				return menuItem;
			}).bind(this));
		}

		registerEvents() {
			window.addEventListener(     'resize',     this.resize.bind(this));

			if (this.isTouchDevice || this.isSideMenu) {
				this.menuItems.forEach((menuItem => {
					if (menuItem.title && menuItem.hasSubMenu) {
						menuItem.title.addEventListener('click', (this.titleClick.bind(this)).bind(this));
					}
				}).bind(this));
			}

			this.header.addEventListener('mouseenter', this.headerMouseOver.bind(this));
			this.header.addEventListener('mousemove',  this.headerMouseOver.bind(this));
			this.header.addEventListener('mouseleave', this.headerMouseLeave.bind(this));

			this.toggle.addEventListener('click',      this.toggleOffscreenMenu.bind(this));
		}

		headerMouseOver(e) {
			let target   = e.target,
				overItem = target.classList.contains('menu-item') || target.classList.contains('header-menu-languages')
						 ? target
						 : target.closest('.menu-item, .header-menu-languages');

			this.menuItems = !this.isSideMenu ? this.menuItems.map(((menuItem, i) => {
				let isVisibleItem = menuItem.element == overItem || (menuItem == this.hoverTarget && overItem == null);

				menuItem.isVisible = isVisibleItem;

				if (menuItem.hasSubMenu) {
					menuItem.element.classList.toggle('show-megamenu', isVisibleItem);

					if (this.isSmallDevice || this.isSideMenu)
						menuItem.subMenu.style.maxHeight = isVisibleItem ? menuItem.subMenu.scrollHeight + 'px' : 0;
				}

				if (isVisibleItem)
					overItem = menuItem;

				return menuItem;
			}).bind(this)) : this.menuItems;

				
			if (overItem == this.languages && this.languages !== null) {
				this.languages.classList.add('show');
			} else if (overItem !== null) {
				imgPreloader.loadImagesNow(overItem.element);
				vidPreloader.loadVideosNow(overItem.element);
				if (this.languages) this.languages.classList.remove('show');
			}

			this.hoverTarget = overItem;
		}

		headerMouseLeave(e) {
			this.hoverTarget = null;
			if (this.languages) this.languages.classList.remove('show');

			if (this.isSideMenu) return;

			this.menuItems = this.menuItems.map(menuItem => {
				menuItem.element.classList.remove('show-megamenu');
				menuItem.isVisible = false;

				if ((this.isSmallDevice || this.isSideMenu) && menuItem.hasSubMenu)
					menuItem.subMenu.style.maxHeight = 0;

				return menuItem;
			});
		}

		titleClick(e) {
			let target = e.target.classList.contains('menu-item-has-children')
					   ? e.target : e.target.closest('.menu-item-has-children');

			this.menuItems = this.menuItems.map(((menuItem, i) => {
				let isTargetMenu = menuItem.element == target,
					show         = isTargetMenu && !menuItem.isVisible;

				menuItem.isVisible               = show;
				menuItem.element.classList.toggle('show-megamenu', show);

				if (menuItem.hasSubMenu) {
					menuItem.subMenu.style.maxHeight = show ? menuItem.subMenu.scrollHeight + 'px' : 0;
				}

				if (!show && menuItem.link) {
					link.click();
				}

				return menuItem;
			}).bind(this));

		}

	/*	Toggle offscreen menu */
		toggleOffscreenMenu() {
			this.header.classList.toggle('show-menu');
		}
	}


	var toggleSubMenus = function() {
		var click2 = function(e) {
			var elem    = e.target.closest('.menu-item-has-children'),
				submenu = elem.querySelector('.header-megamenu'),
				link    = elem.querySelector('.menu-item-top-inner a'),
				show    = !elem.classList.contains('show-megamenu');
			
			elem.classList.toggle('show-megamenu', show);
			submenu.style.maxHeight = show ? submenu.scrollHeight + 'px' : 0;

			if (show) {
				submenus.forEach(function(otherSubmenu) {
					if (otherSubmenu == elem) return;

					var submenu = otherSubmenu.querySelector('.header-megamenu');

					otherSubmenu.classList.remove('show-megamenu');
					submenu.style.maxHeight = 0;
				});
			} else if (link && !e.target.classList.contains('chevron') && !e.target.classList.contains('menu-item-top-chevron')) {
				link.click();
			}
		};
	}







	/***************************************
		Expandable items
	***************************************/

	var expandableItems = function() {
		var elems = [].slice.call(document.querySelectorAll('.expandable'));
		if (!elems) return;

		let threshold = 640;

		elems.forEach(function(elem) {
			var slideUp   = elem.querySelector('.expandable-slideup'),
				toggles   = [].slice.call(elem.querySelectorAll('.expandable-toggle')),
				content   = elem.querySelector('.expandable-inner'),
				isVisible = false;

			var toggleState = function() {
				isVisible = !isVisible;
				elem.classList.toggle('show', isVisible);	
				toggles.forEach(toggle => toggle.innerText = toggle.getAttribute(isVisible ? 'data-content-active' : 'data-content-inactive') || toggle.innerText);
				resize();
			};

			var resize = function() {
				content.style.maxHeight = '';
				content.style.maxHeight = isVisible ? content.scrollHeight + 'px' : 0;

				if (!slideUp) return;

				let slideUpShift = toggles[0].scrollHeight + toggles[0].offsetTop,
					height       = elem.scrollHeight + slideUpShift;

				slideUp.style.transform = isVisible && vpWidth() < threshold
										? 'translateY(' + (-slideUpShift) + 'px)' : '';
				slideUp.style.height    = isVisible && vpWidth() < threshold
									    ? height + 'px'
									    : '100%';

				content.style.maxHeight = isVisible ? (content.scrollHeight + slideUpShift) + 'px' : 0;
			};

			toggles.forEach(toggle => toggle.addEventListener('click', toggleState));
			document.addEventListener('resize', resize);

			resize();
		});
	};




	/***************************************
		Search
	***************************************/

	var search = function() {
		var elem = document.querySelector('.header-search');
		if (!elem) return;

		var toggle    = elem.querySelector('.header-search-toggle'),
			close     = elem.querySelector('.header-searchclose'),
			input     = elem.querySelector('.header-searchinput'),
			count     = elem.querySelector('.searchresult-count'),
			grid      = elem.querySelector('.search-archive'),
			isVisible = false;

		var showSearch = function() {
			elem.classList.add('results-visible');
			isVisible = true;
			input.focus();
		};

		var hideSearch = function() {
			elem.classList.remove('results-visible');
			count.classList.remove('hide');

			input.value     = '';
			count.innerText = '';
			grid.innerHTML  = '';
			isVisible       = false;
		};

		var searchForTerm = function() {
			if (input.value == '') {
				count.classList.add('hide');
				grid.innerHTML = '';
				return;
			}

			var xhr    = xhrCors('POST', localisedew.ajaxurl, true),
				action = 'action=searchForTerm&term=' + input.value;

			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
			xhr.addEventListener('readystatechange', parseSearchResults)
			xhr.send(encodeURI(action));
		};

		var parseSearchResults = function(e) {
			if (e.target.readyState !== 4 || e.target.status !== 200) return;
			var response = JSON.parse(e.target.responseText);

			count.classList.remove('hide');
			count.innerText = response.count;

			if (grid.innerHTML != response.results) {
				grid.innerHTML  = response.results;
				imgPreloader.checkVisibility();
				vidPreloader.checkVisibility();
			}
		};

		toggle.addEventListener('click', showSearch);
		close.addEventListener('click', hideSearch);
		input.addEventListener('input', searchForTerm);
	};




	/***************************************
		Sliders and lightboxes
	***************************************/

	var sliders = function() {
		var elems = [].slice.call(document.querySelectorAll('.slider, .has-lightbox'));
		if (elems.length == 0) return;

		elems.forEach(elem => new Slider(elem));
	}


	class Slider {
		constructor(slider) {
			this.slider    = slider;
			this.build();
		};

		build() {
			if (!this.slider) return;

			this.slideContainer	= this.slider.querySelector('.slider-inner, .lightbox-inner');
			if (!this.slideContainer) return;

			this.navContainer	   = this.slider.querySelector('.slider-nav, .lightbox-nav');
			this.slides			   = [].slice.call(this.slideContainer.querySelectorAll('.slide, .lightbox-item'));
			this.images            = [].slice.call(this.slideContainer.querySelectorAll('.lightbox-image'));
			this.buttons		   = [].slice.call(this.slider.querySelectorAll('.slider-btn'));
			this.toggles           = [].slice.call(this.slider.querySelectorAll('.lightbox-toggle'));
			this.header            = document.querySelector('.header');
			this.followingElem     = this.slider.nextElementSibling;
			this.total			   = this.slides.length;
			this.currentSlide	   = 0;

			this.isLightbox        = this.slider.classList.contains('has-lightbox');
			this.isShrinking       = this.followingElem && this.followingElem.classList.contains('slider') && this.slider.classList.contains('is-scrollover');
			this.isMovingSlider    = this.slider.classList.contains('is-moving');
			this.isOnlyLightbox    = this.isLightbox && !this.slider.classList.contains('slider');
			this.isSelfResizing    = this.slider.classList.contains('is-self-resizing');
			this.isOuterResizing   = this.slider.classList.contains('is-outer-resizing');

			this.autoplay          = this.slider.dataset.duration || 0;
			this.autoplayTimer     = null;
			this.isAutoplayActive  = false;
			this.loop              = this.autoplay !== 0;
			this.isSliding		   = false;
			this.isLightboxVisible = false;

			this.maxShrinkFactor   = 4;

			this.registerEvents();
			this.slideTo(0, true);
		}

		registerEvents() {
			var swipeDetected = this.swipeDetected.bind(this);
			this.swiper = new SwipeDetect(this.slider, swipeDetected, { stagger: 200, vertical: false });

			if (this.navContainer) {
				this.navContainer.querySelector('.nav-prev').addEventListener('click', this.prevSlideNoAutoplay.bind(this));
				this.navContainer.querySelector('.nav-next').addEventListener('click', this.nextSlideNoAutoplay.bind(this));
			}

			if (this.buttons) {
				this.buttons.forEach((function(btn) {
					btn.addEventListener('click', (function() {
						this.slideTo(btn.dataset.index);
					}).bind(this));
				}).bind(this));
			}

			if (this.isShrinking) {
				this.scrollAndShrink();

				window.addEventListener('scroll', this.scrollAndShrink.bind(this));
				window.addEventListener('resize', this.scrollAndShrink.bind(this));
			}

			if (this.isMovingSlider) {
				window.addEventListener('resize', this.resize.bind(this));
			}

			if (this.isLightbox && this.toggles.length > 0) {
				this.toggles.forEach((function(toggle) {
					toggle.addEventListener('click', (e => this.toggleLightBox(e)).bind(this));
				}).bind(this));
			}

			if (this.isSelfResizing) {
				window.addEventListener('resize', this.resizeIndividualSlides.bind(this));
				this.resizeIndividualSlides();
			}

			if (this.isOuterResizing) {
				window.addEventListener('resize', this.resizeSliderOuter.bind(this));
				setTimeout(() => this.resizeSliderOuter(), 100);
			}

			if  (this.autoplay !== 0) {
				let options = {
					threshold: 0.3
				};

				this.autoplayObserver = new IntersectionObserver(this.checkAutoplayInView.bind(this), options);
				this.autoplayObserver.observe(this.slider);
			}

			document.addEventListener('keydown', this.keydown.bind(this));
		}

		resize() {
			this.slideTo(this.currentSlide, true);
		}

		resizeIndividualSlides() {
			let maxHeight = 0;

			this.slideContainer.style.height = '';

			this.slides.forEach(slide => {
				slide.style.height = '';
				maxHeight = Math.max(maxHeight, slide.offsetHeight);
			});

			this.slideContainer.style.height = maxHeight + 'px';
		}


		resizeSliderOuter() {
			let minHeight = parseFloat(getComputedStyle(this.slider).getPropertyValue('--minHeight'));

			this.slider.style.minHeight = '';

			this.slides.forEach(slide => {
				let fg       = slide.querySelector('.slide-fg'),
				    fgHeight = fg ? fg.offsetHeight + parseFloat(getComputedStyle(fg)['margin-top']) : 0;

				minHeight = Math.max(minHeight, fgHeight + 40);
			});

			this.slider.style.minHeight = minHeight + 'px';
		}


		slideTo(target, force) {
			if (this.isOnlyLightbox && !this.isLightboxVisible) return;
			
			target = parseInt(target);

			if (!force && (this.isSliding || target === this.currentSlide)) return;
			if (target < 0) {
				if (!this.loop) return;
				target = this.total - 1;
			}

			if (target >= this.total) {
				if (!this.loop) return;
				target = 0;
			}

			this.isSliding = true;
			if (force) this.slideContainer.classList.add('no-transition');

			this.slides.forEach(slide => slide.dataset.index == target ? slide.classList.add('active') : null);

			if (this.isMovingSlider) {
				let offset = this.slides[target].offsetLeft;
				this.slideContainer.style.transform = 'translateX(-' + offset + 'px)';
			}

			this.buttons.forEach(btn  => btn.classList.toggle('active',     btn.dataset.index == target));
			this.slider.classList.toggle('is-first-slide', !this.loop && target == 0);
			this.slider.classList.toggle('is-last-slide', !this.loop && target == this.total - 1);

			for (let i = -1; i < 2; i++) {
				let index = target + i;
				if (!this.slides[index]) continue;

				imgPreloader.loadImagesNow(this.slides[index]);
				vidPreloader.loadVideosNow(this.slides[index]);
			}

			this.slides.forEach(slide => slide.classList.toggle('active', slide.dataset.index == target));
			this.currentSlide = target;
			this.isSliding = false;

			if (this.isAutoplayActive) {
				clearTimeout(this.autoplayTimer);
				this.autoplayTimer = setTimeout(this.nextSlide.bind(this), this.autoplay);
			}			

			if (force) 
				setTimeout((() => this.slideContainer.classList.remove('no-transition')).bind(this), 400);
		}

		prevSlide() {
			this.slideTo(this.currentSlide - 1);
		}

		nextSlide() {
			this.slideTo(this.currentSlide + 1);
		}

		prevSlideNoAutoplay() {
			clearTimeout(this.autoplayTimer);
			this.prevSlide();
		}

		nextSlideNoAutoplay() {
			clearTimeout(this.autoplayTimer);
			this.nextSlide();
		}

		swipeDetected(e) {
			if (this.isOnlyLightbox && !this.isLightboxVisible) return;
			if (e.directionX == 0) return;				

			var directionDegrees = e.direction2D * 180 / Math.PI + 90;		// down: 0°, clockwise

			while (directionDegrees <=   0) directionDegrees += 360;
			while (directionDegrees >= 360) directionDegrees -= 360;

			var	isRight          = directionDegrees >= 225 && directionDegrees <= 315,
				isLeft           = directionDegrees >= 45  && directionDegrees <= 135;

			if (isRight) 	this.prevSlideNoAutoplay();
			if (isLeft) 	this.nextSlideNoAutoplay();
		}

		scrollAndShrink() {
			let headerHeight     = this.header.getBoundingClientRect().height,
				preceding        = this.slider.previousElementSibling ? this.slider.previousElementSibling.getBoundingClientRect() : 0,
				precedingBottom  = preceding !== 0 ? preceding.bottom : 0,
				followingBGColor = getComputedStyle(this.followingElem)['background-color'],
				followingPos     = this.followingElem.offsetTop - window.scrollY,
				innerWidth       = 100;

			if (followingPos > 0 && followingPos < vpHeight()) {
				innerWidth = 100 - this.maxShrinkFactor * (1 - (followingPos - headerHeight) / vpHeight());
			}

			this.slider.style.setProperty('--width', Math.min(100, innerWidth) + '%');
			this.slider.style.backgroundColor = innerWidth <= 100
											  ? followingBGColor
											  : '';
		}

		keydown(e) {
			if (this.isOnlyLightbox && !this.isLightboxVisible) return;
			if (!this.isSliderVisible()) return;
			
			let key = e.keyCode;
			
			if (key == 27)	this.toggleLightBox();		// ESC
			if (key == 37)	this.prevSlideNoAutoplay();			// arrow left
			if (key == 39)	this.nextSlideNoAutoplay();			// arrow right
		}

		isSliderVisible() {
			let rect = this.slider.getBoundingClientRect()
			return -rect.top < rect.height && rect.bottom < rect.height + vpHeight()
			    && -rect.left < rect.width && rect.right < rect.width + vpWidth();
		}

		toggleLightBox(e = false) {
			let isMaximizer = e && (e.target.classList.contains('tile-maximize') || e.target.closest('.tile-maximize'));

			this.isLightboxVisible = !this.isLightboxVisible;
			this.slider.classList.toggle('show-lightbox', this.isLightboxVisible);
			this.images.forEach((img => img.classList.toggle('cover-container', !this.isLightboxVisible)).bind(this));
			this.slideContainer.style.transform = '';

			if (!this.isLightboxVisible || !isMaximizer) return;

			let slide = e.target.closest('.lightbox-item');
			this.slideTo(slide.dataset.index, true);
		}


		checkAutoplayInView(entries) {
			entries.forEach(entry => {
				this.isAutoplayActive = entry.isIntersecting;

				if (this.isAutoplayActive)
					this.slideTo(0, true);
				else
					clearTimeout(this.autoplayTimer);
			});
		}
	}





	/***************************************
		Resize iframes
	***************************************/

	var resizeIframes = function(parent) {
		parent = parent || document;

		var containers = parent.querySelectorAll('.module:not(.module-youtube) .video-container');
		if (!containers) return;

		var sizeThis = function() {
			[].forEach.call(containers, function(container) {

				var iframe = container.querySelector('iframe:not(.video-embed-player), embed:not(.video-embed-player)');
				if (!iframe) return;

				var parent      = container.parentNode,
					width       = iframe.getAttribute('width'),
					height      = iframe.getAttribute('height');

				if (isNaN(width) || isNaN(height)) {
					while (container.firstChild) parent.insertBefore(container.firstChild, container);
					parent.removeChild(container);
					return;
				}

				var	ratio        = width / height,
					parentWidth  = parent.offsetWidth,
					parentHeight = parent.offsetHeight,
					parentRatio  = parentWidth / parentHeight;

				container.classList.remove('full-width', 'full-height');
				container.style.paddingBottom = '';
				container.style.paddingLeft = '';

				if (ratio >= parentRatio) {
					container.classList.add('full-width');
					container.style.paddingBottom = (100 / ratio) + '%';
				} else {
					container.classList.add('full-height');
					container.style.paddingLeft = (ratio * parentHeight) + 'px';
					container.style.paddingBottom = parentHeight + 'px';
				}
			});
		}

		sizeThis();
		window.addEventListener('resize', sizeThis);
	}




	/***************************************
		Contact form
	***************************************/

	var contactForms = function() {
		var elems = [].slice.call(document.querySelectorAll('.module-contactform, .module-outreach-email .outreach-mail-inner, .module-outreach-brevo #sib-form-container'));
		if (!elems) return;

		elems.forEach(function(elem) {
			var form               = elem.querySelector('form'),
				fields             = [].slice.call(form.querySelectorAll('input, select, textarea')),
				hiddenFields       = [].slice.call(form.querySelectorAll('.form-field-hidden')),
				submit             = form.querySelector('.form-submit'),
				formMsg            = form.querySelector('.form-message'),
				postID             = elem.dataset.parentId,
				formID             = elem.dataset.moduleId,
				isOutreach         = elem.classList.contains('outreach-mail-inner'),
				isBrevo            = elem.classList.contains('outreach-brevo-inner'),
				allValid           = false;

			var toggleHiddenField = function(e) {
				let target = e.target.classList.contains('show-field') ? e.target : e.target.closest('.show-field');
				target.closest('.form-field-hidden').classList.toggle('show');
			}
			
			var checkValidity = async function() {
				allValid           = true;
				formMsg.innerHTML  = '';
				form.classList.remove('submit-success');
				submit.classList.add('disabled');

				await Promise.all(fields.map(async function(field) {
					var parent     = field.closest('.form-field'),
						label      = parent.querySelector('label'),
						errorMsg   = parent.querySelector('.field-error'),
						validity   = field.validity,
						isValid    = validity.valid,
						isRequired = field.required,
						isEmpty    = field.value == '' || field.value == '-1',
						name       = field.dataset.title,
						errorText  = '';

				//	honeypot for spam bots, should not be validated
					if (name == 'firstname')
						return;

					let checked = await checkReferralCode(field, isValid);
					isValid = checked !== null ? checked : isValid;

					if (name !== 'disclaimer') {
						if (validity.valueMissing)
							errorText = localisedewcf['empty' + name];
						if (validity.patternMismatch || validity.typeMismatch) {
							errorText = localisedewcf['wrong' + name];
						}

						if (errorMsg)
							errorMsg.innerHTML = !isValid && !isEmpty ? errorText : '';

						parent.classList.toggle('invalid', !isValid && !isEmpty);
						parent.classList.toggle('valid',    isValid && !isEmpty);
					}

					allValid = await allValid && (isValid && !(isRequired && isEmpty));
				}));

				submit.classList.toggle('disabled', !allValid);
			};


			var checkReferralCode = function(field, isValid) {
				return new Promise((resolve) => {
					if (!field.classList.contains('outreach-referral') || field.value == '')
						return resolve(isValid);

					let xhr     = xhrCors('POST', localisedew.ajaxurl, true),
						action  = '',
						value   = field.value,
						request = 'action=outreachform_referral&postID=' + postID + '&formID=' + formID + '&referralcode=' + field.value;


					xhr.onreadystatechange = function() {
						if (this.responseText.length == 0) return;
						if (value !== field.value) return;

						let response = JSON.parse(this.responseText);

						isValid = response.msg == 'valid' || response.msg == 'none';
						resolve(isValid);
					};

					xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
					xhr.setRequestHeader('Accept', 'application/json');
					xhr.send(encodeURI(request));
				});
			}



			var submitForm = function(e) {
				e.preventDefault();
				if (submit.classList.contains('disabled'))
					return;

				checkValidity();
				if (!allValid) return;

				var url     = new URL(window.location.href),
					data    = fields.map(function(field) {
						var name  = field.type == 'checkbox' ? field.name : field.getAttribute('data-title'),
							value = field.type == 'checkbox' ? field.checked : field.value || field.innerText;

						return name + '=' + value;
					}),
					xhr     = xhrCors('POST', localisedew.ajaxurl, true),
					action  = isOutreach ? 'outreachform' : 'contactform',
					request = 'action=' + action + '&postID=' + postID + '&formID=' + formID + '&' + data.join('&'),
					success = '<h3 class="success-title gamma is-bold">' + localisedewcf.successTitle + '</h3><h4 class="success-text beta">' + localisedewcf.successText + '</h4>';

				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

				xhr.onreadystatechange = function() {
					let text = this.responseText.trim();
					if (text == '') return;
										
					formMsg.innerHTML = text == 'success' ? success : text;
					formMsg.classList.add('show');
				};
		
				xhr.send(encodeURI(request));

				setTimeout(function() {
					formMsg.innerHTML = success;
					form.classList.add('submit-success');
				}, 300);
			};

			fields.forEach(field => field.addEventListener('input', checkValidity));
			hiddenFields.forEach(field => field.querySelector('.show-field').addEventListener('click', toggleHiddenField));

			if (!isBrevo) {
				submit.addEventListener('click', submitForm);
				form.addEventListener('submit', submitForm);
			} else {
				checkValidity();
			}
		});
	};





	/***************************************
		Prevent Scroll
	***************************************/

	var preventDefaultScroll = function(e) {
		e = e || window.event;
		if (e.preventDefault)
			e.preventDefault();
		e.returnValue = false;
	};

	var preventDefaultForScrollKeys = function(e) {
		var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };
		if (keys[e.keyCode]) {
			preventDefaultScroll(e);
			return false;
		}
	}

	var disableScroll = function() {
		var wheelOpt = supportsPassiveEvents() ? { passive: false } : false,
			wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

		window.addEventListener('DOMMouseScroll', preventDefaultScroll, false);
		window.addEventListener(wheelEvent, preventDefaultScroll, wheelOpt);
		window.addEventListener('touchmove', preventDefaultScroll, wheelOpt);
		window.addEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	var enableScroll = function() {
		var wheelOpt = supportsPassiveEvents() ? { passive: false } : false,
			wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

		window.removeEventListener('DOMMouseScroll', preventDefaultScroll, false);
		window.removeEventListener(wheelEvent, preventDefaultScroll, wheelOpt);
		window.removeEventListener('touchmove', preventDefaultScroll, wheelOpt);
		window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
	}

	var supportsPassiveEvents = function() {
		var supportsPassive = false;

		try {
			window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
				get: function() { supportsPassive = true; }
			}));
		} catch(e) {}

		return supportsPassive;
	}



	/***************************************
		Show language sub menu
	***************************************/

	var showLanguageSubMenu = function() {
		var elem = document.querySelector('.header-menu-languages');
		if (!elem) return;

		var toggle = elem.querySelector('.lang-chevron');

		var toggleNow = function() {
			elem.classList.toggle('show');
		}

		if (toggle)
			toggle.addEventListener('click', toggleNow);
	}



	/***************************************
		Section slider
	***************************************/

	var leftRightSections = function() {
		let elems = [].slice.call(document.querySelectorAll('.module-leftrightsections'));
		if (!elems) return;

		elems.forEach(elem => {
			let snapDuration = parseInt(elem.dataset.snapDuration);
			new LeftRightSections(elem, { slideVelocity: snapDuration });
		});
	}

	class LeftRightSections {
		constructor(element, args = {}) {
			this.element                = element;
			this.inner                  = element.querySelector('.leftrightsections-inner');
			this.slides                 = [].slice.call(this.inner.querySelectorAll('.leftrightsections-slide'));
			this.total                  = this.slides.length;
			this.nav                    = element.querySelector('.leftrightsections-nav');
			this.navItems               = [].slice.call(this.nav.querySelectorAll('.leftrightsections-nav-btn'));
			this.header                 = document.querySelector('.header');
			this.html                   = document.querySelector('html');

			this.isLocking              = this.element.classList.contains('snap-lock');
			this.isMobile               = false;
			this.currentSlide           = 0;

			if (!this.isLocking) return;

			this.isSliding              = false;
			this.scrollLock             = 'none';
			this.hasSlid                = false;
			this.hasUpdatedNav          = false;
			this.swiper                 = null;
			this.lastScrollTime         = null;
			this.lastScrollPosition     = 0;
			this.isScrollingIntoView    = false;
			this.isFullHeight           = null;
			this.isMouseDown            = false;

			this.parseSettings(args);
			this.setCurrentSlide();
			this.registerEvents();
			this.resize();
			this.catchPassingScroll();
		}

		parseSettings(args) {
			let defaults = {
				easing: 				    'easeInOutExp',
				slideVelocity:				500,
				slideCoolDown:				1200,
				minVisibilityKey:			0.8,	// percentage of total element height
				minVisibilityCatchScroll:	0.8,	// percentage of total element height
				minVisibilitySnap:          0.7,	// percentage of total element height
				minVisibilityTouchLock:		0.8,	// percentage of total element height
				swipeStagger:				200,
				mobileThreshold:            640,
				fullHeightThreshold:        10/7
			}

			this.settings = Object.assign(defaults, args);
		}

		setCurrentSlide() {
			let rect = this.element.getBoundingClientRect();

			if (rect.top > 0) 				this.currentSlide = 0;
			if (rect.bottom < vpHeight())	this.currentSlide = this.total - 1;

			imgPreloader.loadImagesNow(this.slides[0]);
			vidPreloader.loadVideosNow(this.slides[0]);

			this.slideTo(this.currentSlide, true);
		}

		registerEvents() {
			this.navItems.forEach((i => i.addEventListener('click', this.navigateByNavItems.bind(this))).bind(this));
			
			let swipeDetected = this.onSwipe.bind(this);
			this.swiper = new SwipeDetect(this.element, swipeDetected, { stagger: this.settings.swipeStagger, horizontal: true, passive: false });

			this.element.addEventListener('wheel', this.onWheel.bind(this), { passive: false });
			this.element.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: false });

			this.element.addEventListener('mousedown', this.onMouseDown.bind(this));
			this.element.addEventListener('mouseup', this.onMouseUp.bind(this));

			document.addEventListener('keydown', this.onKeyDown.bind(this));
			document.addEventListener('wheel',   this.onDocumentWheel.bind(this), { passive: false });
			document.addEventListener('scroll',  this.catchPassingScroll.bind(this), { passive: false });
			window.addEventListener(  'resize',  this.resize.bind(this));
		}

		resize() {
			this.lastScrollPosition = getScrollPos();
			this.isMobile           = vpWidth() < this.settings.mobileThreshold;
			this.isFullHeight       = vpWidth() / vpHeight() > this.settings.fullHeightThreshold;

			if (this.isVisible(this.settings.minVisibilityCatchScroll))
				this.slideTo(this.currentSlide, true);
		}

		slideTo(target, force = false) {
			if (this.isSliding               && force == false) return;
			if (this.isScrollingIntoView     && force == false) return;
			if (this.currentSlide === target && force == false) return;

			if (target > this.total - 1) return;
			if (target < 0)              return;

			this.scrollElementIntoView();
			this.isSliding     = true;
			this.hasSlid       = true;
			this.hasUpdatedNav = false;

			let startPos     = -this.currentSlide,
				targetPos    = -target,
				targetCSS    = `calc(${targetPos} * var(--sliderHeight))`,
				startTime    = null,
				previousTime = null;

			for (let i = -1; i <= 1; i++) {
				if (target + i < 0 && target + i > this.total - 1) continue;

				imgPreloader.loadImagesNow(this.slides[target + i]);
				vidPreloader.loadVideosNow(this.slides[target + i]);
			}

			let scrollStep = function(timeStamp) {
				startTime = startTime || timeStamp;

				let elapsed = timeStamp - startTime,
					done    = false;

				if (previousTime !== timeStamp) {
					let progress = this.getProgressEasing(elapsed / this.settings.slideVelocity),
						newPos   = startPos + progress * (targetPos - startPos),
						cssPos   = `calc(${newPos} * var(--sliderHeight))`;

					this.inner.style.transform = `translateY(${cssPos})`;
					if (!this.hasUpdatedNav && progress >= 0.5) this.updateNavItems(target);
					done = newPos == targetPos;
				}

				if (elapsed >= this.settings.slideVelocity) return finishUp.bind(this)();
				
				previousTime = timeStamp;

				if (done) return finishUp.bind(this)();
				
				requestAnimationFrame(scrollStep.bind(this));
			}

			let finishUp = function() {
				this.inner.style.transform = `translateY(${targetCSS}})`;
				this.currentSlide          = target;
				this.isSliding             = false;
				if (!this.hasUpdatedNav) this.updateNavItems(target);

				if (target > 0 && target < this.total - 1)	this.scrollLock = 'both';
				else										this.scrollLock = target == 0 ? 'down' : 'up';
			}

			requestAnimationFrame(scrollStep.bind(this));
		}

		updateNavItems(target) {
			let currentSlide = this.slides[target],
				img          = currentSlide.querySelector('img');

			if (img) {
				let isOverImage   = !((target % 2 == 0) !== this.element.classList.contains('start-right')),
					hasImageData  = img.dataset.brightness !== '',
					imgBrightness = img.dataset.brightness.split(','),
					isDarkImage   = imgBrightness.reduce((acc, val, index) => index % 3 == 2 ? acc + val : acc) > 1,
					slideBg       = getComputedStyle(currentSlide)['background-color'],
					isBgDark      = slideBg.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/).slice(1).map(n => isNaN(n) ? 0 : parseInt(n)).reduce((acc, val) => acc + val) / 3 < 127;

				let isDark        = !this.isMobile && (isOverImage ? hasImageData && isDarkImage : isBgDark),
					isLight       =  this.isMobile || (isOverImage ? hasImageData && !isDarkImage : !isBgDark);				

				this.nav.classList.toggle('dark', isDark);
				this.nav.classList.toggle('light', isLight);
			} else {
				this.nav.classList.remove('dark');
				this.nav.classList.add('light');
			}

			this.navItems.forEach(i => i.classList.toggle('active', i.dataset.index == target));
			this.hasUpdatedNav = true;
		}

		onKeyDown(e) {
			if (!this.isVisible(this.settings.minVisibilityKey)) return;

			switch (e.keyCode) {
				case 33: 		// page up
				case 37: 		// arrow left
				case 38: 		// arrow up
				case 87: 		// W
					if (this.currentSlide > 0) {
						e.preventDefault();
						this.prev();
					}

					break;
				case 13: 		// enter
				case 32: 		// spacebar
				case 14: 		// page down
				case 39: 		// arrow right
				case 40: 		// arrow down
				case 83: 		// S
					if (this.currentSlide < this.total -1) {
						e.preventDefault();
						this.next();
					}

					break;
				case 35: 		// end
					if (this.currentSlide < this.total -1) {
						e.preventDefault();
						this.slideTo(this.total - 1);
					}

					break;
				default:
					break;
			}
		}

		onMouseDown() {
			this.isMouseDown = true;
		}

		onMouseUp() {
			this.isMouseDown = false;
		}

		onSwipe(e) {
			if (this.isMouseDown) return;
			if (Math.abs(e.distanceX) > Math.abs(e.distanceY)) return;

			if (e.directionY == -1 && this.currentSlide > 0) {
				this.prev();
				e.event.preventDefault();
				this.scrollElementIntoView();
			} else if (e.directionY == 1 && this.currentSlide < this.total - 1) {
				this.next();
				e.event.preventDefault();
				this.scrollElementIntoView();
			}
	
		}

		onTouchMove(e) {
			this.ignoreOrReactToEvent(e);
		}

		onWheel(e) {
			let handleEvent = this.ignoreOrReactToEvent(e);
			if (handleEvent == 'tooearly') return;

			if (e.deltaY < 0 && this.currentSlide > 0) {
				this.prev();
				e.preventDefault();
			} else if (e.deltaY >= 0 && this.currentSlide < this.total - 1) {
				this.next();
				e.preventDefault();
			}
		}

		onDocumentWheel(e) {
			if (!this.isVisible(this.settings.minVisibilityCatchScroll)) return;
			if (this.isScrollingIntoView) return e.preventDefault();

			let scrollDirection = this.getScrollDirection(e);
			if (scrollDirection == 'both' || scrollDirection == this.scrollLock) {
				this.scrollElementIntoView();
				return e.preventDefault();
			}
		}

		scrollElementIntoView() {
			return;

			if (!this.hasSlid || this.isScrollingIntoView) return;

			let headerRect = this.header.getBoundingClientRect(),
				elemRect   = this.element.getBoundingClientRect(),
				scrollTop  = window.pageYOffset || document.documentElement.scrollTop,
				top        = elemRect.top + scrollTop - headerRect.height;

			this.isScrollingIntoView = true;

			window.scrollTo({ behavior: 'smooth', top: top, left: 0 });
			setTimeout((() => this.isScrollingIntoView = false).bind(this), 500);
		}

		catchPassingScroll(e = null) {
			if (!this.isScrollingIntoView)
				this.html.classList.toggle('is-snapping', this.isVisible(this.settings.minVisibilitySnap));

			if (!this.isVisible(this.settings.minVisibilityCatchScroll)) return;

			let scrollDirection = this.getScrollDirection(e);

		//	if the user is continueing to scrolling in the same direction, don't do anything at all
			if ((scrollDirection == 'both' || scrollDirection == this.scrollLock) && e)
				return e.preventDefault();
		
		//	if it's at an inbetween slide, continue to scroll
			if (this.currentSlide > 0 && this.currentSlide < this.total - 1) return;

		//	if it's already scrolling into view, don't do anything at all
			if (this.isScrollingIntoView) {
				if (e) e.preventDefault();
				return;
			}

			let handleEvent = this.ignoreOrReactToEvent(e);
			if (handleEvent == 'tooearly') return;

			let elemRect     = this.element.getBoundingClientRect(),
				elemTop      = elemRect.top,
				headerHeight = this.header.getBoundingClientRect().height;

			// scrolling down while the element is emerging from below
			if (scrollDirection == 'down' && elemTop > headerHeight) {
				this.scrollElementIntoView();
				this.scrollLock = 'down';
			// scrolling up while the element is emerging from the top
			} else if (scrollDirection == 'up' && elemTop < headerHeight) {
				this.scrollElementIntoView();
				this.scrollLock = 'up';
			}
		}

		ignoreOrReactToEvent(e) {
			let timeStamp = Date.now();

			if (this.lastScrollTime !== null && timeStamp - this.lastScrollTime < this.settings.slideCoolDown) {
				if (this.currentSlide == 0 && e.deltaY < 0) return 'reachedlimit';
				if (this.currentSlide == this.total - 1 && e.deltaY > 0) return 'reachedlimit';

				if ('preventDefault' in e) e.preventDefault();
				return 'tooearly';
			}

			this.lastScrollTime = timeStamp;
			return 'pass';
		}

		getScrollDirection(e = null) {
			let newPos  = getScrollPos(),
				lastPos = this.lastScrollPosition;

			this.lastScrollPosition = newPos;

			if (e) {
				if (e.deltaY)      return e.deltaY      > 0 ? 'down' : (e.deltaY      < 0 ? 'up' : 'no-scroll');
				if (e.wheelDeltaY) return e.wheelDeltaY < 0 ? 'down' : (e.wheelDeltaY > 0 ? 'up' : 'no-scroll');
			}

			return lastPos < newPos ? 'down' : (lastPos > newPos ? 'up' : 'no-scroll');
		}

		prev() {
			this.slideTo(this.currentSlide - 1);
		}

		next() {
			this.slideTo(this.currentSlide + 1);
		}

		navigateByNavItems(e) {
			let target = e.target.classList.contains('leftrightsections-nav-btn')
					   ? e.target
					   : e.target.querySelector('.leftrightsections-nav-btn');

			this.slideTo(parseInt(target.dataset.index));
		}

		isVisible(threshold = 0.8) {
			let height        = vpHeight(),
				rect          = this.element.getBoundingClientRect(),
				visibleHeight = rect.height;

			if (rect.top < 0) 			visibleHeight += rect.top;
			if (rect.bottom > height)	visibleHeight += height - rect.bottom;;

			return visibleHeight / rect.height >= threshold;
		}

		getProgressEasing(progress = 0) {
			let easings = {
				linear:          x => x,

				easeInSine:      x => 1 - Math.cos((x * Math.PI) / 2),
				easeInQuad:      x => Math.pow(x, 2),
				easeInCubic:     x => Math.pow(x, 3),
				easeInQuart:     x => Math.pow(x, 4),
				easeInQuint:     x => Math.pow(x, 5),
				easeInExpo:      x => x === 0 ? 0 : Math.pow(2, 10 * x - 10),
				easeInCirc:      x => 1 - Math.sqrt(1 - Math.pow(x, 2)),
				easeInBack:      x => 2.70158 * x * x * x - 1.70158 * x * x,

				easeOutSine:     x => Math.sin((x * Math.PI) / 2),
				easeOutQuad:     x => 1 - Math.pow(1 - x, 2),
				easeOutCubic:    x => 1 - Math.pow(1 - x, 3),
				easeOutQuart:    x => 1 - Math.pow(1 - x, 4),
				easeOutQuint:    x => 1 - Math.pow(1 - x, 5),
				easeOutExpo:     x => x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
				easeOutCirc:     x => Math.sqrt(1 - Math.pow(x - 1, 2)),
				easeOutBack:     x => 1 + 2.70158 * Math.pow(x - 1, 3) + 1.70158 * Math.pow(x - 1, 2),

				easeInOutSine:   x => -(Math.cos(Math.PI * x) - 1) / 2,
				easeInOutQuad:   x => x < 0.5 ?  2 * Math.pow(x, 2) : 1 - Math.pow(-2 * x + 2, 2) / 2,
				easeInOutCubic:  x => x < 0.5 ?  4 * Math.pow(x, 3) : 1 - Math.pow(-2 * x + 2, 3) / 2,
				easeInOutQuart:  x => x < 0.5 ?  8 * Math.pow(x, 4) : 1 - Math.pow(-2 * x + 2, 4) / 2,
				easeInOutQuint:  x => x < 0.5 ? 16 * Math.pow(x, 5) : 1 - Math.pow(-2 * x + 2, 5) / 2,
				easeInOutExpo:   x => x == 0 ? 0 : (x == 1 ? 1 : (x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2)),
				easeInOutCirc:   x => x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
				easeInOutBack:   x => x < 0.5 ? (Math.pow(2 * x, 2) * (7.189819 * x - 2.5949095)) / 2 : (Math.pow(2 * x - 2, 2) * (3.5949095 * (x * 2 - 2) + 2.5949095) + 2) / 2 
			};

			if (easings[this.settings.easing]) return easings[this.settings.easing](progress);
			return easings['easeInOutExpo'](progress);
		}
	}



	/***************************************
		Logo bar
	***************************************/

	var logoBar = function() {
		let elems  = [].slice.call(document.querySelectorAll('.module-logobar')),
			header = document.querySelector('.header');
		if (!elems || !header) return;

		let threshold   = 640,
			scrollStart = 0.8,
			scrollEnd   = 0.1,
			posMargin   = 0.05;

		let update = function() {
			let headerHeight = header.getBoundingClientRect().height;

			elems.forEach(elem => {
				let inner = elem.querySelector('.logobar-inner'),
					logos = elem.querySelector('.logobar-logos');

				if (vpWidth() < threshold) {
					logos.style.transform = '';
					return;
				}
				
				let margin            = posMargin * vpWidth(),
					innerRect         = inner.getBoundingClientRect(),
					logosSpace        = innerRect.width,
					logosTotal        = logos.scrollWidth,
					logosDisplacement = innerRect.width - logosTotal - 2 * margin;

				if (logosDisplacement > 0) {
					elem.classList.add('not-scrolling');
					return logos.style.transform = 'none';
				}

				let	scrollPos         = Math.min(Math.max((innerRect.top - headerHeight) / vpHeight(), scrollEnd), scrollStart),
					scrollPosRelative = (scrollPos - scrollStart) / (scrollEnd - scrollStart),
					x                 = margin - (Math.abs(logosDisplacement * scrollPosRelative));


				elem.classList.remove('not-scrolling');
				logos.style.transform = 'translateX(' + x + 'px)';
			});
		};

		update();

		window.addEventListener('scroll', update);
		window.addEventListener('resize', update);
	}




	/***************************************
		Infinity scroller
	***************************************/

	var infinityScroller = function() {
		let elems = [].slice.call(document.querySelectorAll('.module-infinityscroller'));
		if (elems.length == 0) return;

		let header                 = document.querySelector('.header:not(.transparent)'),
			opacityThresholdTop    = 0.5,
			opacityThresholdBottom = 0.3,
			maxSlidesShrinkFactor  = 7;

		let update = function() {
			let headerHeight = header ? header.offsetHeight : 0;

			elems.forEach(elem => {
				let slides           = [].slice.call(elem.querySelectorAll('.slide')),
					elemPos          = elem.getBoundingClientRect(),
					following        = elem.nextElementSibling || document.querySelector('.footer'),
					followingBGColor = getComputedStyle(following)['background-color'];

				slides.forEach((slide, i) => {
					let slideRect  = slide.getBoundingClientRect(),
						background = slide.querySelector('.infinityscroll-bg'),
						foreground = slide.querySelector('.infinityscroll-fg'),
						captions   = [].slice.call(slide.querySelectorAll('.infinityscroll-caption-inner')),
						height     = background.offsetHeight,
						fgRect     = foreground.getBoundingClientRect(),
						isCurrent  = fgRect.top < 0.5 * height && fgRect.bottom > 0.5 * height,
						opacity    =  slideRect.top    >= 0          ? 1 - slideRect.top / vpHeight()
							       : (slideRect.bottom <= vpHeight() ?     slideRect.bottom / vpHeight() : 1);

					if (i == 0)                 isCurrent = fgRect.top < height       && fgRect.bottom > 0.5 * height;
					if (i == slides.length - 1) isCurrent = fgRect.top < 0.5 * height && fgRect.bottom > 0;
					
					slide.classList.toggle('current-slide', isCurrent);
					background.style.opacity = opacity;

					if (isCurrent) {
						imgPreloader.loadImagesNow(slide);
						vidPreloader.loadVideosNow(slide);
					}

					captions.forEach((caption, j) => {
						let rect    = caption.getBoundingClientRect(),
							opacity = rect.top > 0.5 * height
									? (1 - rect.top / height) / opacityThresholdBottom
									: 2 * (rect.bottom - headerHeight) / height / opacityThresholdTop;

						opacity = Math.min(Math.max(opacity, 0), 1);
						caption.style.opacity = opacity;
					});
				});

				elem.classList.toggle('reached-start', elemPos.top >= 0);
				elem.classList.toggle('reached-end', elemPos.bottom <= vpHeight());

				let bottom     = Math.max(0, elemPos.bottom - headerHeight),
					innerWidth = Math.min(100, 100 - maxSlidesShrinkFactor * (1 - bottom / vpHeight()));

				elem.style.setProperty('--width', innerWidth + '%');

				elem.style.backgroundColor = elemPos.bottom - headerHeight <= vpHeight()
										   ? followingBGColor
										   : '';
			});
		};

		update();

		window.addEventListener('scroll', update);
		window.addEventListener('resize', update);
	}



	/***************************************
		Maintenance check
	***************************************/

	var maintenanceCheck = function() {
		let elem = document.querySelector('.page-maintenance');
		if (!elem) return;

		let delay   = 3000,
			request = new XMLHttpRequest();

		request.open('HEAD', window.location, true);

		request.onload = function() {
			if (this.status >= 200 && this.status < 400) window.location.reload();
			else 										 setTimeout(maintenanceCheck, delay);
		}

		request.onerror = function() {
			setTimeout(maintenanceCheck, delay);
		}

		request.send();
	}



	/***************************************
		Hide header bar
	***************************************/

	var hideHeaderBar = function() {
		let header = document.querySelector('.header.header-slide-up');
		if (!header) return;

		let threshold      = 2,
			scrollPosition = getScrollPos();

		let update = function() {
			let newScrollPosition = getScrollPos(),
				isHidden          = header.classList.contains('slide-up'),
				belowThreshold    = newScrollPosition >= threshold * vpHeight() && newScrollPosition >= scrollPosition;

			if (!isHidden && belowThreshold) {
				header.classList.add('slide-up');
			} else if (isHidden && !belowThreshold) {
				header.classList.remove('slide-up');
			}

			scrollPosition = newScrollPosition;
		};

		update();
		window.addEventListener('resize', update);
		document.addEventListener('scroll', update);
	}




	/***************************************
		Smart tiles
	***************************************/

	var smartTiles = function() {
		let elems = [].slice.call(document.querySelectorAll('.module-smarttiles'));
		if (elems.length == 0) return;

		elems.forEach(elem => {
			let inner     = elem.querySelector('.smarttiles-items');
			if (!inner) return;

			let	tiles                 = [].slice.call(inner.querySelectorAll('.smarttiles-item')),
				navBtns               = [].slice.call(elem.querySelectorAll('.smarttiles-nav-btn')),
				btnPrev               = elem.querySelector('.smarttiles-nav-prev'),
				btnNext               = elem.querySelector('.smarttiles-nav-next'),
				current               = 0,
				mediaPreloadThreshold = -0.4;

			let scrollToLeft = function() {
				scrollTo(current - 1);
			};

			let scrollToRight = function() {
				scrollTo(current + 1);
			};

			let scrollTo = function(index) {
				let paddingLeft = parseFloat(getComputedStyle(elem).paddingLeft),
					gap         = parseFloat(getComputedStyle(inner).columnGap);

				current = Math.max(Math.min(index, tiles.length - 1), 0);

				inner.style.left = `-${tiles[current].offsetLeft + paddingLeft - gap}px`;
				navBtns.forEach((btn, i) => btn.classList.toggle('active', i == current));

				imgPreloader.checkVisibility(mediaPreloadThreshold);
				vidPreloader.checkVisibility(mediaPreloadThreshold);
			}

			let updateButtons = function() {
				let maxPos = inner.scrollWidth - inner.clientWidth;

				if (btnPrev) btnPrev.classList.toggle('disabled', inner.scrollLeft <= 0);
				if (btnNext) btnNext.classList.toggle('disabled', inner.scrollLeft >= maxPos - 2);
			};

			let resize = function() {
				scrollTo(current);
				updateButtons();
			};

			let toggleOverlay = function(e) {
				let tile      = e.target.classList.contains('smarttiles-item') ? e.target : e.target.closest('.smarttiles-item'),
					isVisible = !elem.classList.contains('show-overlay');

				elem.classList.toggle('show-overlay', isVisible);
				tile.classList.toggle('show-overlay', isVisible);

				if (isVisible) {
					disableScroll();
				} else {
					enableScroll();
				}
			};


			let swipeDetected = function(e) {
				if (e.directionX == 0) return;				

				var directionDegrees = e.direction2D * 180 / Math.PI + 90;		// down: 0°, clockwise

				while (directionDegrees <=   0) directionDegrees += 360;
				while (directionDegrees >= 360) directionDegrees -= 360;

				var	isRight = directionDegrees >= 225 && directionDegrees <= 315,
					isLeft  = directionDegrees >= 45  && directionDegrees <= 135;

				if (isRight) scrollToLeft();
				if (isLeft)  scrollToRight();
			}


			tiles.forEach(tile => {
				let toggles = [].slice.call(tile.querySelectorAll('.smarttiles-overlay-toggle'));
				toggles.forEach(toggle => toggle.addEventListener('click', toggleOverlay));
			});

			if (btnPrev) btnPrev.addEventListener('click', scrollToLeft);
			if (btnNext) btnNext.addEventListener('click', scrollToRight);

			let swiper = new SwipeDetect(elem, swipeDetected, { stagger: 200, horizontal: true, passive: false });


			inner.addEventListener('scroll', updateButtons);
			window.addEventListener('resize', resize);

			resize();
		});
	}




	/***************************************
		Checklist
	***************************************/

	var checklist = function() {
		let elems = [].slice.call(document.querySelectorAll('.module-checklist'));
		if (elems.length == 0) return;

		let options = {
				rootMargin: '0px',
				threshold: 0.25
			},
			observer;

		let update = function(entries) {
			entries.forEach(entry => {
				if (!entry.isIntersecting) return;

				entry.target.classList.add('reveal-checklist');
				observer.unobserve(entry.target);
			});
		};

		observer = new IntersectionObserver(update, options);
		elems.forEach(elem => observer.observe(elem));
	};



	/***************************************
		Videos
	***************************************/

	var videos = function() {
		var elems = [].slice.call(document.querySelectorAll('.module-video'));
		if (!elems) return;


		class VideoPlayer {
			constructor(elem) {
				this.id                     = Math.random();
				this.baseVolume             = 0.8;
				this.blockScrollKeys        = false;
				this.hideControlsOnPlay     = true;
				this.hideControlsDelay      = 2000;

				this.elem                   = elem;
				this.type                   = null;
				this.player                 = null;
				this.registerVideoType();

				if (!this.player) return;

				this.width                  = this.player.width;
				this.height                 = this.player.height;
				this.fullscreenHandlers     = [];

				this.hasLoaded              = false;
				this.hasTriggeredFullscreen = false;
				this.isAutoplay             = this.player.isAutoplay;
				this.isMuted                = this.isAutoplay;
				this.startMuted             = this.isMuted;
				this.isPlaying              = null;
				this.isSeekingByProgressBar = false;
				this.isVolumeByVolumeBar    = false;
				this.isLoaded               = false;
				this.isLoading              = false;
				this.currentTime            = 0;
				this.duration               = null;
				this.volume                 = this.baseVolume;

				this.ui                     = {
					playPause:         this.elem.querySelector('.btn-play-pause'),
					currentTime:       this.elem.querySelector('.current-time'),
					totalTime:         this.elem.querySelector('.total-time'),
					volumeBar:         this.elem.querySelector('.volume-bar'),
					volumeBarInner:    this.elem.querySelector('.volume-bar-inner'),
					muteButton:        this.elem.querySelector('.btn-mute'),
					fsButton:          this.elem.querySelector('.btn-fullscreen'),
					progressBar:       this.elem.querySelector('.progress-bar'),
					progressBarBuffer: this.elem.querySelector('.progress-bar-buffer'),
					progressBarTime:   this.elem.querySelector('.progress-bar-time')
				};

				this.prepareVideo();
				this.findFullScreenHandlers();

				this.setVolume(this.volume);

				if (this.startMuted)
					this.mute(true);

				this.registerEvents();
			}

			registerVideoType() {
				let classes = this.elem.classList;
				if (classes.contains('module-native-video')) {
					this.type = 'native';
					this.player = new NativeVideoPlayer(this.elem, this);
				} else if (classes.contains('module-vimeo')) {
					this.type = 'vimeo';
					this.player = new VimeoPlayer(this.elem, this);
				} else if (classes.contains('module-youtube')) {
					this.type = 'youtube';
					this.player = new YouTubePlayer(this.elem, this);
					youTubeInstances.push(this.player);
				}
			}

			registerEvents() {
				window.addEventListener('resize',                      this.checkVisibility.bind(this), false);
				window.addEventListener('scroll',                      this.checkVisibility.bind(this), { passive: false });
				window.addEventListener('scroll',                      this.pausePlayerOnScroll.bind(this));


			/*	Keyboard */
				document.addEventListener('keydown',                   this.keyDownHandler.bind(this));

			/*	Mouse events */
				if (this.ui.playPause)
					this.ui.playPause.addEventListener('click',        this.togglePlayPause.bind(this));

				if (this.ui.fsButton)
					this.ui.fsButton.addEventListener( 'click',        this.toggleFullScreen.bind(this));

				if (this.ui.muteButton)
					this.ui.muteButton.addEventListener('click',       this.toggleMute.bind(this));

				if (this.ui.volumeBar) {
					this.ui.volumeBar.addEventListener('mousedown',    this.volumeByVolumeBarStart.bind(this));
					this.ui.volumeBar.addEventListener('mousemove',    this.volumeByVolumeBar.bind(this));
					this.ui.volumeBar.addEventListener('mouseup',      this.volumeByVolumeBarEnd.bind(this));

					this.ui.volumeBar.addEventListener('touchstart',   this.volumeByVolumeBarStart.bind(this));
					this.ui.volumeBar.addEventListener('touchmove',    this.volumeByVolumeBar.bind(this));
					this.ui.volumeBar.addEventListener('touchend',     this.volumeByVolumeBarEnd.bind(this));
				}

				if (this.ui.progressBar) {
					this.ui.progressBar.addEventListener('mousedown',  this.seekByProgressBarStart.bind(this));
					this.ui.progressBar.addEventListener('mousemove',  this.seekByProgressBar.bind(this));
					this.ui.progressBar.addEventListener('mouseup',    this.seekByProgressBarEnd.bind(this));

					this.ui.progressBar.addEventListener('touchstart', this.seekByProgressBarStart.bind(this));
					this.ui.progressBar.addEventListener('touchmove',  this.seekByProgressBar.bind(this));
					this.ui.progressBar.addEventListener('touchend',   this.seekByProgressBarEnd.bind(this));
				}

				if (this.hideControlsOnPlay) {
					this.elem.addEventListener('mouseenter',           this.showControls.bind(this));
					this.elem.addEventListener('mousemove',            this.hideControlsFullscreen.bind(this));
					this.elem.addEventListener('mouseleave',           this.hideControls.bind(this));
				}

				document.addEventListener('mouseup',                   this.releaseAllMouseDownHandlers.bind(this));
			}

			findFullScreenHandlers() {
				let d        = document,
					e        = d.documentElement,
					handlers = {
						callOnVideo: false,
						isFullscreenVideo: this.player.isFullscreenVideo,
						isFullscreen: () => d.fullscreen || d.fullScreen || d.webkitIsFullScreen || d.mozFullScreen || d.msFullscreenElement || false
					};

				     if (e.requestFullScreen)					handlers.request = e.requestFullScreen;
				else if (e.mozRequestFullScreen)				handlers.request = e.mozRequestFullScreen;
				else if (e.webkitRequestFullScreen)				handlers.request = e.webkitRequestFullScreen;
				else if (e.webkitRequestFullscreen)				handlers.request = e.webkitRequestFullscreen;
				else if (e.webkitEnterFullScreen)				handlers.request = e.webkitEnterFullScreen;
				else if (e.msRequestFullscreen)					handlers.request = e.msRequestFullscreen;
				else if (e.requestFullscreen)					handlers.request = e.requestFullscreen;
				else if (this.player.webkitEnterFullscreen) {
					handlers.request = this.player.webkitEnterFullscreen;
					handlers.callOnVideo = true;
				}

					 if (d.exitFullscreen)					handlers.exit    = d.exitFullscreen;
				else if (d.mozCancelFullScreen)				handlers.exit    = d.mozCancelFullScreen;
				else if (e.webkitExitFullScreen)			handlers.exit    = e.webkitExitFullScreen;
			  	else if (d.webkitExitFullscreen)			handlers.exit    = d.webkitExitFullscreen;
				else if (d.msExitFullscreen)				handlers.exit    = d.msExitFullscreen;
				else if (this.player.webkitExitFullScreen)	{
					handlers.exit = this.player.webkitExitFullScreen;
					handlers.callOnVideo = true;
				}

				document.addEventListener('fullscreenchange',       this.onFullscreenChange.bind(this));
				document.addEventListener('mozfullscreenchange',    this.onFullscreenChange.bind(this));
				document.addEventListener('webkitfullscreenchange', this.onFullscreenChange.bind(this));
				document.addEventListener('MSFullscreenChange',     this.onFullscreenChange.bind(this));

				this.fullscreenHandlers = handlers;
			}

			keyDownHandler(e) {
				if (!this.isPlayerVisible()) return;
				if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;

				let code           = e.keyCode,
					preventDefault = true;

				switch (code) {
					case 27: 		// Escape
						this.exitFullscreen();
						break;
					case 32: 		// space bar
						preventDefault = !this.blockScrollKeys;
						if (preventDefault) this.togglePlayPause();
						break;
					case 37: 		// arrow left
						this.seekTo(this.currentTime - 5);
						break;
					case 38: 		// arrow top
						preventDefault = !this.blockScrollKeys;
						if (preventDefault) this.setVolume(this.volume + 0.1);
						break;
					case 39: 		// arrow right
						this.seekTo(this.currentTime + 5);
						break;
					case 40: 		// arrow bottom
						preventDefault = !this.blockScrollKeys;
						if (preventDefault) this.setVolume(this.volume - 0.1);
						break;
					case 48: 		// 0-9
					case 49:
					case 50:
					case 51:
					case 52:
					case 53:
					case 54:
					case 55:
					case 56:
					case 57:
						this.seekTo(this.duration * 0.1 * (code - 48))
						break;
					case 70: 		// F
						this.toggleFullScreen();
						break;
					case 74: 		// J
						this.seekTo(this.currentTime - 10);
						break;
					case 75: 		// K
						this.togglePlayPause();
						break;
					case 76: 		// L
						this.seekTo(this.currentTime + 10);
						break;
					case 77: 		// M
						this.toggleMute();
						break;
					default:
						preventDefault = false;
						break;
				}

				if (preventDefault)
					e.preventDefault();
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onEnded(e) {
				this.seekTo(0);
			}

			onLoaded(e) {
				this.elem.classList.add('has-loaded');
				this.elem.classList.remove('is-loading');

				this.duration  = this.player.duration;
				this.hasLoaded = true;
				this.isLoading = false;
				this.isLoaded  = true;

				if (this.ui.currentTime)
					this.ui.currentTime.innerText = this.formatTime(0);

				if (this.ui.totalTime)
					this.ui.totalTime.innerText = this.formatTime(this.duration);

				if (this.ui.currentTime || this.ui.totalTime) {
					this.elem.classList.remove('time-segments-1', 'time-segments-2', 'time-segments-3');
					this.elem.classList.add('time-segments-' + this.getDurationSectionsAmount());
				}

				if (this.isAutoplay)
					this.isPlaying = true;
			}

			onPaused(e) {
				this.isPlaying = false;
				this.elem.classList.remove('is-playing');
			}

			onPlayerError(e) {
				console.warn(e);
			}

			onPlaying(e) {
				this.isPlaying = true;
				this.elem.classList.add('is-playing');
			}

			onProgress(sections) {
				if (!this.ui.progressBarBuffer) return;

				let canvas    = this.ui.progressBarBuffer,
					context   = canvas.getContext('2d'),
					increment = canvas.width / this.duration;

				context.clearRect(0, 0, canvas.width, canvas.height);
				context.fillStyle = '#fff';

				for (let i = 0; i < sections.length; i++) {
					let start = sections[i].start,
						end   = sections[i].end,
						width = (end - start) * increment;

					context.fillRect(start, 0, width, canvas.height);
				}
			}

			onTimeUpdate(e) {
				this.currentTime = this.player.currentTime;

				if (this.ui.currentTime)
					this.ui.currentTime.innerText = this.formatTime(this.currentTime)
				if (this.ui.progressBarTime)
					this.ui.progressBarTime.style.width = (100 * this.currentTime / this.duration) + '%';
			}

			onVolumeChange(e) {
				this.isMuted = this.player.isMuted;
				this.elem.classList.toggle('is-muted', this.isMuted);
			}



			/************************************************
			 * 	Preparing and loading appropriate version
			 * **********************************************/

			prepareVideo() {
				if (this.type == 'youtube') return;

				let parentWidth = this.elem.scrollWidth,
					newHeight   = this.height * parentWidth / this.width;

				this.player.setHeight(newHeight);
			}

			checkVisibility() {
				if (this.loaded) return;

				debounce((function() {
					if (this.isPlayerVisible())
						this.loadVideo();

				}).bind(this));
			}

			loadVideo() {
				if (this.type == 'youtube') return;
				this.player.loadVideo();
			}



			/************************************************
			 * 	Event listeners
			 * **********************************************/

			onFullscreenChange(e) {
				if (!this.hasTriggeredFullscreen) return;

				let isFullScreen = this.isFullscreen();
				if (isFullScreen)	disableScroll();
				else  				enableScroll();

				document.body.classList.toggle('is-fullscreen', isFullScreen);
				this.elem.classList.toggle('is-fullscreen', isFullScreen);

				if (!isFullScreen) {
					let behaviorSupported = 'scrollBehavior' in document.documentElement.style,
						videoPos          = this.elem.getBoundingClientRect(),
						scrollTop         = getScrollPos(),
						scrollLeft        = window.pageXOffset || document.documentElement.scrollLeft,
						top               = videoPos.top + scrollTop - 0.5 * (vpHeight() - videoPos.height),
						left              = videoPos.left + scrollLeft - 0.5 * (vpWidth() - videoPos.width);

					if (false)	window.scrollTo({ top: top, left: left, behavior: 'smooth' });
					else  		window.scrollTo(left, top);

					this.hasTriggeredFullscreen = false;
				}
			}



			/************************************************
			 * 	Controls
			 * **********************************************/

			exitFullscreen() {
				if (!this.isFullscreen() || !this.fullscreenHandlers.exit) return;

				if (this.fullscreenHandlers.callOnVideo)	this.fullscreenHandlers.exit();
				else 										this.fullscreenHandlers.exit.call(document);

				this.elem.classList.remove('is-fullscreen');
			}

			isFullscreen() {
				return !!(this.fullscreenHandlers.isFullscreen());
			//	return !!(this.fullscreenHandlers.callOnVideo ? this.video.webkitDisplayingFullscreen : this.fullscreenHandlers.isFullscreen());
			}

			mute(initialOverride = false) {
				if (this.isMuted && !initialOverride) return;

				this.oldVolume = this.volume;
				this.setVolume(0);
				this.player.mute();
				this.isMuted = true;
				this.elem.classList.add('is-muted');
				this.hideControlsFullscreen();
			}

			pause() {
				if (!this.isPlaying) return;
				this.player.pause();
				this.showControls();
			}

			play() {
				if (this.isPlaying) return;
				this.player.play();
				this.hideControlsFullscreen();

				if (!this.elem.classList.contains('has-played')) {
					this.elem.classList.add('has-played');

					this.isPlaying = true;
					this.showControls();
				}
			}

			requestFullscreen() {
				if (this.isFullscreen() || !this.fullscreenHandlers.request) return;

				this.hasTriggeredFullscreen = true;

				if (this.fullscreenHandlers.callOnVideo)	this.video.webkitEnterFullscreen();
				else 										this.fullscreenHandlers.request.call(document.documentElement);

				this.elem.classList.add('is-fullscreen');
				this.hideControlsFullscreen();
			}

			stop() {
				this.player.pause();
			}

			seekTo(time) {
				time = this.minmax(time, 0, this.duration);
				this.player.seekTo(time);
			}

			setVolume(volume) {
				this.volume = this.minmax(volume, 0, 1);
				this.player.setVolume(this.volume);
				this.isMuted = false;

				if (this.ui.volumeBarInner)
					this.ui.volumeBarInner.style.transform = 'scaleX(' + this.volume + ')';
			}

			unmute() {
				if (!this.isMuted) return;
				this.setVolume(this.oldVolume ? this.oldVolume : this.baseVolume);
				this.player.unmute();
				this.isMuted = false;
				this.elem.classList.remove('is-muted');
				this.hideControlsFullscreen();
			}



			/************************************************
			 * 	UI controls
			 * **********************************************/

			hideControls() {
				if (!this.hideControlsOnPlay) return;

				this.controlsTimeout = setTimeout((() => {
					if (!this.isPlaying) return;
					this.elem.classList.add('hide-controls');
				}).bind(this), this.hideControlsDelay);
			}

			hideControlsFullscreen() {
				if (!this.hideControlsOnPlay || !this.isFullscreen()) return;

				this.showControls();
				this.hideControls();
			}

			pausePlayerOnScroll() {
				if (this.isPlayerVisible()) return;
				this.pause();
			}

			releaseAllMouseDownHandlers() {
				this.isSeekingByProgressBar = false;
				this.isVolumeByVolumeBar    = false;
			}

			seekByProgressBarStart() {
				this.isSeekingByProgressBar = true;
			}

			seekByProgressBar(e) {
				if (!this.isSeekingByProgressBar) return;

				let seekPercentage = this.getProgressPercentage(e, this.ui.progressBar);
				this.seekTo(seekPercentage * this.duration);
			}

			seekByProgressBarEnd(e) {
				this.seekByProgressBar(e);
				this.isSeekingByProgressBar = false;
				this.hideControlsFullscreen();
			}

			showControls() {
				if (!this.hideControlsOnPlay || this.isPlaying === null) return;

				this.elem.classList.remove('hide-controls');
				if (this.controlsTimeout)
					clearTimeout(this.controlsTimeout);
			}

			toggleFullScreen() {
				if (this.isFullscreen())	this.exitFullscreen();
				else  						this.requestFullscreen();
			}

			toggleMute() {
				if (this.isMuted)	this.unmute();
				else  				this.mute();
			}

			togglePlayPause() {
				if (this.isPlaying)	this.pause();
				else  				this.play();
			}

			volumeByVolumeBarStart() {
				this.isVolumeByVolumeBar = true;
			}

			volumeByVolumeBar(e) {
		
				if (!this.isVolumeByVolumeBar) return;

				let volumePercentage = this.getProgressPercentage(e, this.ui.volumeBar);

				this.setVolume(volumePercentage);
				this.isMuted = volumePercentage == 0;
				this.elem.classList.toggle('is-muted', volumePercentage == 0);
			}

			volumeByVolumeBarEnd(e) {
				this.volumeByVolumeBar(e);
				this.isVolumeByVolumeBar = false;
				this.hideControlsFullscreen();
			}



			/************************************************
			 * 	Helper functions
			 * **********************************************/

			formatTime(time) {
				let amountSections = this.getDurationSectionsAmount(),
					hours          = String(Math.floor(time / 3600)).padStart(2, '0'),
					minutes        = String(Math.floor(time / 60 % 60)).padStart(2, '0'),
					seconds        = String(Math.floor(time % 60)).padStart(2, '0');

				return [hours, minutes, seconds].slice(3 - amountSections).join(':');
			}

			getDurationSectionsAmount() {
				return this.duration >= 3600 ? 3 : 2;
			}

			getProgressPercentage(e, elem) {
				let x     = 0,
					rect = elem.getBoundingClientRect();

				if (e.type == 'touchmove' || e.type == 'touchend') {
					let event = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent,
						touch = event.touches[0] || event.changedTouches[0];
					x = touch.clientX - rect.left;
				} else if (e.type == 'mouseup' || e.type == 'mousemove') {
					x = e.layerX;
				}

				return x / rect.width;
			}

			isPlayerVisible() {
				let rect = this.elem.getBoundingClientRect()
				return -rect.top < rect.height && rect.bottom < rect.height + vpHeight()
				    && -rect.left < rect.width && rect.right < rect.width + vpWidth();
			}

			minmax(value, min, max) {
				return Math.max(Math.min(value, max), min);
			}
		}



		/************************************************
		* 	Native Video Player
		* **********************************************/

		class NativeVideoPlayer {
			constructor(elem, parent) {
				this.threshold  = 500;

				this.parent     = parent;
				this.elem       = elem;
				this.video      = elem.querySelector('video');
				this.sources    = this.video.dataset.sources;
				if (!this.sources) return;

				this.sources    = JSON.parse(this.sources);
				this.width      = this.video.width;
				this.height     = this.video.height;

				this.duration   = null;
				this.isAutoplay = this.video.autoplay == '1';
				this.isMuted    = this.isAutoplay;
				this.volume     = this.parent.baseVolume;

				this.parent.checkVisibility();
				this.registerEvents();
			}

			registerEvents() {
				this.video.addEventListener('ended',               this.onEnded.bind(this));
				this.video.addEventListener('error',               this.onPlayerError.bind(this));
				this.video.addEventListener('loadedmetadata',      this.onLoaded.bind(this));
				this.video.addEventListener('pause',               this.onPaused.bind(this));
				this.video.addEventListener('play',                this.onPlaying.bind(this));
				this.video.addEventListener('progress',            this.onProgress.bind(this));
				this.video.addEventListener('timeupdate',          this.onTimeUpdate.bind(this));
				this.video.addEventListener('volumechange',        this.onVolumeChange.bind(this));

				this.video.addEventListener('click',               this.parent.togglePlayPause.bind(this.parent));

				this.video.addEventListener('webkitendfullscreen', this.parent.onFullscreenChange.bind(this));
				this.video.addEventListener('fullscreenchange',    this.parent.onFullscreenChange.bind(this));
			}

			loadVideo() {
				if (this.parent.isLoading || this.parent.hasLoaded) return;

				this.parent.isLoading = true;
				this.elem.classList.add('is-loading');

				let mimes   = {},
					sources = '';

				this.sources.forEach(file => {
					if (!mimes.hasOwnProperty(file.mime))
						mimes[file.mime] = [];
					mimes[file.mime].push(file);
				});

				for (let mime in mimes) {
					if (!mimes.hasOwnProperty(mime)) continue;

					let sizes = mimes[mime],
						size;

					if (sizes.length >= 2) {
						sizes = sizes.filter(((size, index, arr) => size.width >= this.width).bind(this));
					}

					size     = (sizes.length > 0) ? sizes[sizes.length - 1] : mimes[mime][0];
					sources += '<source src="' + size.file + '" type="' + mime + '">';
				}

				if (this.threshold > vpWidth()) {
					this.video.setAttribute('preload', 'metadata');
				}

				this.video.innerHTML = sources;
				this.video.removeAttribute('data-sources');
				this.video.style.height = '';

				window.removeEventListener('scroll', this.parent.checkVisibility.bind(this));
				window.removeEventListener('resize', this.parent.checkVisibility.bind(this));
			}

			setHeight(newHeight) {
				this.video.style.height = newHeight + 'px';
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onEnded(e) {
				this.parent.onEnded(e);
			}

			onLoaded(e) {
				this.video.setAttribute('playsinline', 'playsinline');
				this.duration = this.video.duration;
				this.parent.onLoaded(e);
			}

			onPaused(e) {
				this.parent.onPaused(e);
			}

			onPlayerError(e) {
				this.parent.onPlayerError(e);
			}

			onPlaying(e) {
				this.parent.onPlaying();
			}

			onProgress() {
				let sections = [];

				for (let i = 0; i < this.video.buffered.length; i++) {
					sections.push({ start: this.video.buffered.start(i), end: this.video.buffered.end(i) });
				}

				this.parent.onProgress(sections);
			}

			onTimeUpdate(e) {
				this.currentTime = this.video.currentTime;
				this.parent.onTimeUpdate(e);
			}

			onVolumeChange(e) {
				this.isMuted = this.video.muted && this.video.volume == 0;
				this.volume  = this.video.volume;
				this.parent.onVolumeChange(e);
			}



			/************************************************
			 * Fullscreen functions
			 * **********************************************/

			isFullscreenVideo = () => this.video.webkitDisplayingFullscreen;
			webkitEnterFullscreen = () => this.video.webkitEnterFullscreen;
			webkitExitFullScreen = () => this.video.webkitExitFullScreen;



			/************************************************
			 * 	Controls
			 * **********************************************/

			mute = () => this.video.muted = true;
			play = () => this.video.play();
			pause = () => this.video.pause();
			seekTo = (time) => this.video.currentTime = time;
			setVolume = (volume) => this.video.volume = volume;
			stop = () => this.video.pause();
			unmute = () => this.video.muted = false;
		}








		/************************************************
		* 	Vimeo Player
		* **********************************************/

		class VimeoPlayer {
			constructor(elem, parent) {
				this.threshold  = 500;

				this.parent     = parent;
				this.elem       = elem;
				this.inner      = elem.querySelector('.video-inner');
				this.id         = this.inner.dataset.id;
				if (!this.id) return;

				this.duration   = null;
				this.isAutoplay = this.inner.dataset.autoplay == '1';
				this.isLooping  = this.inner.dataset.loop == '1';
				this.isMuted    = this.isAutoplay;
				this.startMuted = this.isMuted;
				this.volume     = this.parent.baseVolume;

				this.vimeoOptions = {
					autoplay:    this.isAutoplay,
					byline:      false,
					controls:    false,
					dnt:         true,
					id:          this.id,
					keyboard:    false,
					loop:        this.isLooping,
					muted:       this.startMuted,
					playsinline: true,
					portrait:    false,
					width:       this.inner.clientWidth,
				};

				this.player     = new Vimeo.Player(this.inner, this.vimeoOptions);

				this.parent.checkVisibility();
				this.registerEvents();
			}

			registerEvents() {
				this.player.on(       'ended', this.onEnded.bind(this));
				this.player.on(       'error', this.onPlayerError.bind(this));
				this.player.on(      'loaded', this.onLoaded.bind(this));
				this.player.on(       'pause', this.onPaused.bind(this));
				this.player.on(        'play', this.onPlaying.bind(this));
				this.player.on(    'progress', this.onProgress.bind(this));
				this.player.on(  'timeupdate', this.onTimeUpdate.bind(this));
				this.player.on('volumechange', this.onVolumeChange.bind(this));
			}

			loadVideo() {
				if (this.parent.isLoading || this.parent.hasLoaded) return;

				this.parent.isLoading = true;
				this.elem.classList.add('is-loading');

				return this.player.loadVideo(this.id)
					   .then(() => {
					   		this.player.ready().then(() => {
					   			this.setDimensions(true);
					   			this.setDuration();

					   			this.inner.addEventListener('click', this.parent.togglePlayPause.bind(this.parent));

					   			window.removeEventListener('scroll', this.parent.checkVisibility.bind(this));
								window.removeEventListener('resize', this.parent.checkVisibility.bind(this));
					   		});
					   	})
					   .catch(err => console.error(err));
			}

			setDimensions(force = false) {
				if (force || this.width === null || this.height === null) {
					return this.getDimensions(true).then(((dimensions) => {
						this.width  = dimensions.width;
						this.height = dimensions.height;
						this.setDimensions();
						return { width: this.width, height: this.height };
					}).bind(this));
				}

				this.elem.style.aspectRatio = this.width + ' / ' + this.height;

				return { width: this.width, height: this.height };
			}

			getDimensions(force = false) {
				if (!force && this.width !== null && this.height !== null) {
					return new Promise(function(resolve, reject) {
						return dimensions;
					});
				}

				return Promise.all([this.player.getVideoWidth(), this.player.getVideoHeight()]).then((function(dimensions) {
					return { width: dimensions[0], height: dimensions[1] };
				}).bind(this));
			}

			setDuration() {
				this.player.getDuration().then((function(duration) {
					this.duration = duration;
				}).bind(this));
			}

			setHeight(newHeight) {
				this.inner.style.height = newHeight + 'px';
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onEnded(e) {
				this.parent.onEnded(e);
			}

			onLoaded(e) {
				this.inner.querySelector('iframe').setAttribute('playsinline', 'playsinline');
				this.player.getDuration().then((duration => {
					this.duration = duration;
					this.parent.onLoaded(e);
				}).bind(this))				
			}

			onPaused(e) {
				this.parent.onPaused(e);
			}

			onPlayerError(e) {
				this.parent.onPlayerError(e);
			}

			onPlaying(e) {
				this.parent.onPlaying();
			}

			onProgress(e) {
				this.parent.onProgress([{ start: 0, end: e.seconds }]);
			}

			onTimeUpdate(e) {
				this.currentTime = e.seconds;
				this.parent.onTimeUpdate(e);
			}

			onVolumeChange(e) {
				this.volume = e.volume;
				this.isMuted = e.volume == 0;
				this.parent.onVolumeChange(e);
			}



			/************************************************
			 * Fullscreen functions
			 * **********************************************/

			isFullscreenVideo = () => this.video.webkitDisplayingFullscreen;
			webkitEnterFullscreen = () => this.video.webkitEnterFullscreen;
			webkitExitFullScreen = () => this.video.webkitExitFullScreen;



			/************************************************
			 * 	Controls
			 * **********************************************/

			mute = () => this.player.setMuted(true);
			play = () => this.player.play();
			pause = () => this.player.pause();
			seekTo = (time) => this.player.setCurrentTime(time).then((() => this.currentTime = time).bind(this));
			setVolume = (volume) => this.player.setVolume(volume);
			stop = () => this.player.pause();
			unmute = () => this.player.setMuted(false);
		}



		/************************************************
		* 	YouTube Player
		* **********************************************/

		var youTubeInstances = [];

		var onYouTubeIframeAPIReady = function() {			
			youTubeInstances.forEach(instance => {
				instance.constructPlayer();
			});
		}

		class YouTubePlayer {
			constructor(elem, parent) {
				this.threshold  = 500;

				this.parent     = parent;
				this.elem       = elem;
				this.inner      = elem.querySelector('.video-inner');
				this.iframe     = this.inner.querySelector('iframe');
				this.video      = null;
				this.id         = this.inner.dataset.id;
				if (!this.id) return;

				this.hasInitialised = false;
				this.duration       = null;
				this.isAutoplay     = this.inner.dataset.autoplay == '1';
				this.isLooping      = this.inner.dataset.loop == '1';
				this.isMuted        = this.isAutoplay;
				this.startMuted     = this.isMuted;
				this.volume         = this.parent.baseVolume;

				this.width          = 1;
				this.height         = 1;
				this.timeUpdater    = null;
			}

			constructPlayer() {
				this.width = this.iframe.width;
				this.height = this.iframe.height;

				let width  = this.inner.clientWidth,
					ratio  = this.width / this.height,
					height = width / ratio;

				this.youtubeOptions = {
					videoId:        this.id,
					width:          width,
					height:         height,
					playerVars: {
						autoplay:       this.isAutoplay == '1' ? 1 : 0,
						controls:       0,
						disablekb:      0,
						enablejsapi:    1,
						fs:             0,
						iv_load_policy: 0,
						loop:           this.isLooping == '1' ? 1 : 0,
						modestbranding: 1,
						playsinline:    1,
						rel:            0,
						showinfo:       0,
					},
					events: {
						onError:       this.onPlayerError.bind(this),
						onReady:       this.onLoaded.bind(this),
						onStateChange: this.onStateChange.bind(this)
					}
				};

				this.hasInitialised = true;
				this.player = new YT.Player(this.iframe, this.youtubeOptions);
			}

			setDimensions(force = false) {
				this.inner.style.aspectRatio = this.width + ' / ' + this.height;
				return { width: this.width, height: this.height };
			}

			setDuration() {
				this.duration = this.player.getDuration();
			}



			/************************************************
			 * Video event listeners
			 * **********************************************/

			onStateChange(e) {
				if (e.data == 0) this.onEnded(e);
				if (e.data == 1) this.onPlaying(e);
				if (e.data == 2) this.onPaused(e);
				if (e.data == 3) this.onProgress(e);
				if (e.data == 5) this.onTimeUpdate(e);
			}

			onEnded(e) {
				clearInterval(this.timeUpdater);
				this.parent.onEnded(e);
			}

			onLoaded(e) {
				if (!this.hasInitialised || this.parent.isLoading || this.parent.hasLoaded) return;

				this.parent.isLoading = true;
				this.elem.classList.add('is-loading');

				this.setDimensions(true);
				this.setDuration();
				this.inner.addEventListener('click', this.parent.togglePlayPause.bind(this.parent));
				this.parent.onLoaded(e);
			}

			onPaused(e) {
				clearInterval(this.timeUpdater);
				this.parent.onPaused(e);
			}

			onPlayerError(e) {
				this.parent.onPlayerError(e);
			}

			onPlaying(e) {
				this.timeUpdater = setInterval(this.onTimeUpdate.bind(this), 100);
				this.parent.onPlaying();
			}

			onProgress() {
				this.parent.onProgress([{ start: 0, end: this.player.getVideoLoadedFraction() * this.duration }]);
			}

			onTimeUpdate() {
				this.currentTime = this.player.getCurrentTime();
				this.parent.onTimeUpdate();
			}



			/************************************************
			 * Fullscreen functions
			 * **********************************************/

			isFullscreenVideo = () => this.video.webkitDisplayingFullscreen;
			webkitEnterFullscreen = () => this.video.webkitEnterFullscreen;
			webkitExitFullScreen = () => this.video.webkitExitFullScreen;



			/************************************************
			 * 	Controls
			 * **********************************************/

			mute = () => {
				if (!this.hasInitialised) return;
				this.player.mute();
			}

			play = () => {
				if (!this.hasInitialised) return;
				this.player.playVideo();
			}

			pause = () =>  {
				if (!this.hasInitialised) return;
				this.player.pauseVideo();
			}

			seekTo = (time) => {
				if (!this.hasInitialised) return;
				this.player.seekTo(time);
			}

			setVolume = (volume) => {
				if (!this.hasInitialised) return;
				this.player.setVolume(volume * 100);
				this.volume = volume;
				this.isMuted = volume == 0;
				this.parent.onVolumeChange();
			}

			stop = () => {
				if (!this.hasInitialised) return;
				this.pause();
				this.seekTo(0);
			}

			unmute = () => {
				if (!this.hasInitialised) return;
				this.player.unMute();
			}
		}

		window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
		elems.forEach(e => new VideoPlayer(e));
	}




	/***************************************
		Credits
	***************************************/

	var credits = function() {
		let credits     = '\n\nThis website was designed by Evolvcraft.\nhttps://evolvcraft.com\n\nIt was built by Matthias Planitzer.\nwww.matthias-planitzer.de\n\n',
			scriptSrc   = document.querySelector('#ew_script-js').src;

		if (scriptSrc.indexOf('&c=1') == -1) return;
		console.log('%c' + credits, 'color: #00F; font-family: Helvetica Neue, Helvetica, sans-serif; font-size: 14px;');	
	}








	/***************************************
		Swipe detect
	***************************************/

	class SwipeDetect {
		constructor(elem, callback, args) {
			var defaults = {
				minDistance:       50,
				addMouseEvents:    true,
				addDragDropEvents: true,
				horizontal:        true,
				vertical:          true,
				stagger:           100,
				passive:           true
			};

			this.elem      = elem;
			this.callback  = callback;
			this.args      = Object.assign(defaults, args);

			this.active    = false;
			this.eventType = null;
			this.lastPos   = { x: null, y: null };
			this.lastEmit  = Date.now();
			
			this.registerEvents();
		}

		destruct() {
			this.elem.removeEventListener('touchstart', this.fn.startTouch);
			this.elem.removeEventListener('touchmove',  this.fn.move);
			this.elem.removeEventListener('touchend',   this.fn.end);

			if (this.args.addMouseEvents) {
				this.elem.removeEventListener('mousedown',  this.fn.startMouse);
				this.elem.removeEventListener('mousemove',  this.fn.move);
				this.elem.removeEventListener('mouseleave', this.fn.end);
				 document.removeEventListener('mouseup',    this.fn.end);
			}

			if (this.args.addDragDropEvents) {
				this.elem.removeEventListener('dragstart', this.fn.startDragDrop);
				this.elem.removeEventListener('dragleave', this.fn.end);
				this.elem.removeEventListener('dragexit',  this.fn.end);
				this.elem.removeEventListener('drop',      this.fn.end);
			}
		}

		registerEvents() {
			this.fn = {
				startDragDrop: this.startDragDrop.bind(this),
				startMouse:    this.startMouse.bind(this),
				startTouch:    this.startTouch.bind(this),
				move:          this.move.bind(this),
				end:           this.end.bind(this),
			};

			this.elem.addEventListener('touchstart', this.fn.startTouch, { passive: this.args.passive });
			this.elem.addEventListener('touchmove',  this.fn.move, { passive: this.args.passive });
			this.elem.addEventListener('touchend',   this.fn.end, { passive: this.args.passive });

			if (this.args.addMouseEvents) {
				this.elem.addEventListener('mousedown',  this.fn.startMouse, { passive: this.args.passive });
				this.elem.addEventListener('mousemove',  this.fn.move, { passive: this.args.passive });
				this.elem.addEventListener('mouseleave', this.fn.end, { passive: this.args.passive });
				 document.addEventListener('mouseup',    this.fn.end, { passive: this.args.passive });
			}

			if (this.args.addDragDropEvents) {
				this.elem.addEventListener('dragstart', this.fn.startDragDrop, { passive: this.args.passive });
				this.elem.addEventListener('dragleave', this.fn.end, { passive: this.args.passive });
				this.elem.addEventListener('dragexit',  this.fn.end, { passive: this.args.passive });
				this.elem.addEventListener('drop',      this.fn.end, { passive: this.args.passive });
			}
		}

		startTouch(event) {
			this.active    = true;
			this.eventType = 'touch';
			this.lastPos   = this.getPosition(event);
		}

		startMouse(event) {
			this.active    = true;
			this.eventType = 'mouse';
			this.lastPos   = this.getPosition(event);
		}

		startDragDrop(event) {
			this.active    = true;
			this.eventType = 'dragdrop';
			this.lastPos   = this.getPosition(event);
		}

		move(event) {
			if (!this.active) return;

			var now         = Date.now(),
				timeElapsed = now - this.lastEmit;
			if (timeElapsed < this.args.stagger) return;

			var	newPos      = this.getPosition(event),
				distance    = this.distance(this.lastPos, newPos),
				result      = {
					distance2D:  Math.sqrt(distance.x * distance.x + distance.y * distance.y),
					direction2D: Math.atan2(distance.y, distance.x),
					type:        this.eventType,
					event: 		 event
				};

			if (this.args.horizontal) {
				result.distanceX  = distance.x;
				result.directionX = Math.sign(distance.x / this.args.minDistance);
			}

			if (this.args.vertical) {
				result.distanceY  = distance.y;
				result.directionY = Math.sign(distance.y / this.args.minDistance);
			}
			
			if ((result.directionX !== 0 && this.args.horizontal) ||
				(result.directionY !== 0 && this.args.vertical)) {
				this.lastPos  = newPos;
				this.lastEmit = now;

				this.callback(result);
			}
		}

		end(event) {
			this.active = false;
		}

		getPosition(event) {
			var pos = this.eventType == 'touch' && event.touches ? event.touches[0] : event;
			return { x: pos.clientX, y: pos.clientY };
		}

		distance(pos1, pos2) {
			return { x: pos1.x - pos2.x, y: pos1.y - pos2.y };
		}
	}




	init();
})();